<template>
  <div class="leftjoin-root native-position-filter">
    <!-- 离屏预加载选点地图（单例容器，避免每次打开弹窗重复 new AMap.Map） -->
    <div ref="mapPrewarmWrap" class="leftjoin-map-prewarm" aria-hidden="true">
      <div ref="mapSingletonEl" class="leftjoin-map-singleton-el"></div>
    </div>
    <!-- 展开/收缩按钮 -->
    <div
      class="toggle-btn"
      :class="{ collapsed: isCollapsed }"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="toggleSidebar"
      @keyup.enter.prevent="toggleSidebar"
      @keyup.space.prevent="toggleSidebar"
    >
      <i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
    <div class="main-content" :class="{ 'collapsed': isCollapsed }">
      <div class="left-panel" v-show="!isCollapsed">
        <div v-if="!pluginSingleVnoOnly" class="mode-toggle">
          <el-radio-group v-model="vehicleMode" size="medium" class="mode-toggle__inner">
            <el-radio-button label="single">单车</el-radio-button>
            <el-radio-button label="multi">多车</el-radio-button>
          </el-radio-group>
        </div>

        <!-- 单车：筛选表单（默认收起，点击展开） -->
        <div v-if="vehicleMode === 'single'" class="single-filter-section">
          <el-form
            :model="searchForm"
            :rules="rules"
            ref="searchForm"
            label-position="top"
            class="bicycle-form"
          >
          <div class="form-row">
            <el-form-item label="车牌号" class="form-item" prop="licensePlate">
              <PlateLicenseField
                v-model="searchForm.licensePlate"
                placeholder="输入车牌号"
                :disabled="singleFiltersDisabled"
                :garage-tree-list-url="garageTreeListUrl"
                :garage-tree-list-use-request="garageTreeListUseRequest"
                :garage-tree-children-url="garageTreeChildrenUrl"
                :garage-tree-children-use-request="garageTreeChildrenUseRequest"
                @vehicle-select="onVehiclePlateFromListSelected"
              />
            </el-form-item>
            <el-form-item label="车牌号颜色" class="form-item" prop="licensePlateColor">
              <el-select v-model="searchForm.licensePlateColor" placeholder="请选择" :disabled="singleFiltersDisabled" style="width:100%">
                <el-option v-for="color in plateColorOptions" :key="color.value" :label="color.label" :value="color.value" />
              </el-select>
            </el-form-item>
          </div>

          <div class="single-filter-extra-fields">
            <div class="form-row">
              <el-form-item label="始发地" class="form-item" :prop="requireRouteFields ? 'startAreaCode' : undefined">
                <el-cascader
                  style="width: 100%"
                  size="large"
                  :options="regionOptions"
                  v-model="selectedAreaOrigin"
                  clearable
                  :disabled="singleFiltersDisabled"
                  @change="handleAreaOriginChange"
                />
              </el-form-item>
              <el-form-item label="目的地" class="form-item" :prop="requireRouteFields ? 'endAreaCode' : undefined">
                <el-cascader
                  style="width: 100%"
                  size="large"
                  :options="regionOptions"
                  v-model="selectedAreaDest"
                  clearable
                  :disabled="singleFiltersDisabled"
                  @change="handleAreaDestChange"
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="始发地坐标" class="form-item" :prop="requireRouteFields ? 'originCoord' : undefined">
                <el-input clearable v-model="searchForm.originCoord" placeholder="请选择坐标（选填）" :disabled="singleFiltersDisabled">
                  <el-button slot="append" icon="el-icon-location" @click="openMapDialog('origin')" :disabled="singleFiltersDisabled"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="目的地坐标" class="form-item" :prop="requireRouteFields ? 'destCoord' : undefined">
                <el-input clearable v-model="searchForm.destCoord" placeholder="请选择坐标（选填）" :disabled="singleFiltersDisabled">
                  <el-button slot="append" icon="el-icon-location" @click="openMapDialog('dest')" :disabled="singleFiltersDisabled"></el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>

          <el-form-item v-if="!singleFiltersDisabled" class="single-filter-search-item">
            <el-button type="primary" @click="handleSearch" class="search-btn">查询</el-button>
          </el-form-item>
          </el-form>
        </div>

        <el-dialog
          title="添加车辆"
          :visible.sync="multiAddDialogVisible"
          width="26rem"
          append-to-body
          :close-on-click-modal="false"
          custom-class="multi-add-vehicle-dialog"
          @closed="onMultiAddDialogClosed"
        >
          <div class="multi-add-dialog-body">
            <div class="multi-add-line-actions">
              <div
                class="multi-add-line-add"
                role="button"
                tabindex="0"
                @click="addMultiDraftRow"
                @keyup.enter.prevent="addMultiDraftRow"
              >
                <i class="el-icon-plus"></i>
                <span>车牌号</span>
              </div>
              <el-button
                type="text"
                class="multi-add-batch-btn"
                :disabled="multiFiltersDisabled"
                @click="toggleMultiBatchImport"
              >快捷识别</el-button>
            </div>
            <div v-if="multiBatchImportVisible" class="multi-add-batch-wrap">
              <div class="multi-add-batch-row">
                <el-input
                  v-model="multiBatchImportText"
                  type="textarea"
                  :rows="3"
                  class="multi-add-batch-textarea"
                  :placeholder="batchPlateImportPlaceholder"
                  :disabled="multiFiltersDisabled"
                />
                <el-button
                  type="primary"
                  size="small"
                  :disabled="multiFiltersDisabled"
                  @click="applyMultiBatchRecognize"
                >识别</el-button>
              </div>
            </div>
            <div class="multi-add-rows" :class="{ 'multi-add-rows--scroll': multiAddRowsScrollable }">
              <div v-for="row in multiAddDraftRows" :key="row._rid" class="multi-add-row">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="multi-add-row__del"
                  :disabled="multiFiltersDisabled"
                  @click="removeMultiDraftRow(row._rid)"
                />
                <el-input
                  v-model="row.plate"
                  class="multi-add-row__plate"
                  placeholder="请输入车牌号"
                  maxlength="16"
                  clearable
                  :disabled="multiFiltersDisabled"
                />
                <el-select
                  v-model="row.vco"
                  class="multi-add-row__vco"
                  placeholder="颜色"
                  :popper-append-to-body="true"
                  popper-class="vehicle-add-vco-popper"
                  :disabled="multiFiltersDisabled"
                >
                  <el-option v-for="color in plateColorOptions" :key="color.value" :label="color.label" :value="color.value" />
                </el-select>
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="multiAddDialogVisible = false">取消</el-button>
            <el-button type="primary" :disabled="multiFiltersDisabled" @click="confirmMultiAddDialog">确认</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="addVehicleDialogMode === 'edit' ? '编辑车辆' : '新增车辆'"
          :visible.sync="addVehicleDialogVisible"
          width="30rem"
          append-to-body
          :close-on-click-modal="false"
          custom-class="add-vehicle-dialog"
          @closed="onAddVehicleDialogClosed"
        >
          <el-form
            ref="addVehicleFormRef"
            :model="addVehicleForm"
            :rules="addVehicleRules"
            label-width="6.25rem"
            class="add-group-form"
          >
            <el-form-item label="车辆分组" prop="parentPath">
              <VehicleTeamTreePicker
                v-model="addVehicleForm.parentPath"
                :options="addVehicleGroupTreeOptions"
                placeholder="请选择"
              />
            </el-form-item>
            <el-form-item label="车牌号" prop="vehicleNo">
              <PlateKeyboardInput
                v-model="addVehicleForm.vehicleNo"
                placeholder="请输入车牌号"
              />
            </el-form-item>
            <el-form-item label="别名" prop="aliasName">
              <el-input v-model="addVehicleForm.aliasName" placeholder="请输入别名" clearable maxlength="64" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetAddVehicleFields">
              <i class="el-icon-refresh-left"></i> 重置
            </el-button>
            <el-button type="primary" :disabled="multiFiltersDisabled" @click="submitAddVehicle">
              <i class="el-icon-check"></i> 提交
            </el-button>
          </span>
        </el-dialog>

        <div v-if="vehicleMode === 'multi'" class="multi-selected-slot">
          <div class="multi-filter-panel multi-filter-panel--above-garage">
            <div class="multi-filter-toolbar">
              <div class="multi-filter-toolbar__left">
                <span class="multi-filter-toolbar__title">已选车辆({{ multiSelectedVehicles.length }})</span>
                <button
                  type="button"
                  class="multi-filter-toolbar__toggle"
                  :disabled="multiFiltersDisabled"
                  @click="openMultiSelectedDialog"
                >
                  <span>查看</span>
                  <i class="el-icon-arrow-down"></i>
                </button>
              </div>
              <div class="multi-filter-toolbar__right">
                <el-button
                  type="primary"
                  class="multi-filter-toolbar__query"
                  :disabled="multiFiltersDisabled"
                  @click="handleMultiSearch()"
                >查询</el-button>
              </div>
            </div>
          </div>
        </div>

        <el-dialog
          title="已选车辆"
          :visible.sync="multiSelectedDialogVisible"
          width="56rem"
          append-to-body
          :close-on-click-modal="false"
          custom-class="multi-selected-manage-dialog"
        >
          <div class="multi-selected-dialog">
            <div class="multi-selected-dialog__actions">
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                :disabled="multiFiltersDisabled"
                @click="openMultiAddDialog"
              >添加车辆</el-button>
              <el-button
                size="small"
                icon="el-icon-upload2"
                :disabled="multiFiltersDisabled"
                @click="onMultiExportIn"
              >导入</el-button>
              <el-button
                size="small"
                icon="el-icon-download"
                :disabled="multiFiltersDisabled"
                @click="onMultiExport"
              >导出</el-button>
              <input
                ref="multiImportInput"
                type="file"
                accept=".xlsx"
                style="display:none"
                @change="onMultiImportFileChange"
              />
            </div>
            <el-input
              v-model="multiSelectedDialogSearch"
              size="small"
              clearable
              placeholder="车牌号模糊搜索"
              class="multi-selected-dialog__search"
              :disabled="multiFiltersDisabled"
            />
            <el-table
              :data="multiSelectedDialogTableRows"
              border
              stripe
              size="small"
              max-height="360"
              class="multi-selected-dialog__table"
              empty-text="暂无已选车辆"
            >
              <el-table-column prop="vclN" label="车牌号" min-width="110" show-overflow-tooltip />
              <el-table-column label="车牌颜色" min-width="100"><template slot-scope="scope">{{ plateColorLabel(scope.row.vco) }}</template></el-table-column>
              <el-table-column prop="spdText" label="速度" width="100" show-overflow-tooltip />
              <el-table-column label="查询状态" width="110" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span
                    class="multi-selected-dialog__query"
                    :class="'is-' + scope.row.queryStatusType"
                  >{{ scope.row.queryStatusText }}</span>
                </template>
              </el-table-column>
              <el-table-column label="行驶状态" width="90">
                <template slot-scope="scope">
                  <span
                    class="multi-selected-dialog__status"
                    :class="scope.row.statusType ? ('is-' + scope.row.statusType) : ''"
                  >{{ scope.row.statusText }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="offlineTimeText" label="离线时间" min-width="140" show-overflow-tooltip />
              <el-table-column prop="locationText" label="最后位置" min-width="160" show-overflow-tooltip />
              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    :disabled="multiFiltersDisabled"
                    @click="removeMultiSelected(scope.row._key)"
                  >移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="saveMultiSelectedDialog">保存</el-button>
            <el-button type="primary" @click="saveAndQueryMultiSelectedDialog">保存并查询</el-button>
          </span>
        </el-dialog>

        <div
          v-if="showGaragePanel && multiGarageKeepAlive"
          v-show="vehicleMode === 'multi'"
          class="multi-garage-slot"
        >
          <LeftJoinGaragePanel
            ref="garagePanel"
            :disabled="isFilterDisabled"
            :enable-tree-fetch="showGaragePanel"
            :garage-tree-list-url="garageTreeListUrl"
            :garage-tree-list-use-request="garageTreeListUseRequest"
            :garage-tree-children-url="garageTreeChildrenUrl"
            :garage-tree-children-use-request="garageTreeChildrenUseRequest"
            :show-checkbox="true"
            :vehicle-status-map="garageVehicleStatusMap"
            @apply-vehicle="onGarageApplyVehicle"
            @vehicle-check-change="onGarageVehicleCheckChange"
            @tree-loaded="onGarageTreeLoaded"
          />
        </div>

        <!-- 多车：历史查询车辆 / 结果均隐藏；导入导出已移至已选车辆旁 -->
        <div v-if="vehicleMode === 'single'" class="lower-panel">
          <el-tabs v-model="activeLowerTab" class="lower-tabs">
            <el-tab-pane v-if="!pluginSingleVnoOnly" label="历史查询车辆" name="history">
              <div class="history-vehicle-panel">
                <div class="history-vehicle-toolbar">
                  <el-input
                    v-model="historySearchText"
                    size="small"
                    clearable
                    placeholder="模糊查询车牌/位置..."
                    :disabled="historyFiltersDisabled"
                    class="history-vehicle-toolbar__search"
                  />
                  <el-button
                    size="small"
                    type="danger"
                    plain
                    :disabled="historyFiltersDisabled || !historyVehicleList.length"
                    @click="onClearHistoryVehicles"
                  >清空</el-button>
                </div>
                <div v-if="filteredHistoryVehicleList.length" class="history-vehicle-scroll history-vehicle-scroll--list">
                  <div
                    v-for="(item, idx) in filteredHistoryVehicleList"
                    :key="(item._key || historyVehicleRowKey(item)) + '-' + idx"
                    class="history-vehicle-card"
                    :class="{ 'history-vehicle-card--clickable': !historyFiltersDisabled }"
                    role="button"
                    :tabindex="historyFiltersDisabled ? -1 : 0"
                    :aria-disabled="historyFiltersDisabled ? 'true' : 'false'"
                    @click="onHistoryVehicleClick(item)"
                    @keyup.enter.prevent="onHistoryVehicleClick(item)"
                  >
                    <button
                      type="button"
                      class="history-vehicle-card__delete"
                      aria-label="删除"
                      :disabled="historyFiltersDisabled"
                      @click.stop="onDeleteHistoryVehicle(item)"
                    >×</button>
                    <div class="history-vehicle-card__plate">{{ item.vclN }} · {{ plateColorLabel(item.vco) }}</div>
                    <div class="history-vehicle-card__row">最后定位时间：{{ item.lastTimeText }}</div>
                    <div class="history-vehicle-card__row">最后定位位置：{{ item.locationText }}</div>
                  </div>
                </div>
                <div v-else class="tab-placeholder">暂无历史记录</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="结果" name="result">
              <!-- 单车：文案字段均来自 getTruckLastLocation 的 firstVcl（routeData 即首车对象） -->
              <div class="result-panel result-panel--in-tab">
                <div v-if="routeData" class="result-content">
                  <div class="result-item">预计到达时间: {{ formatResultEstimateTime(routeData.estimateArriveTime) }}</div>
                  <div class="result-item">剩余远距: {{ formatResultKm(routeData.remainDistance) }}</div>
                  <div class="result-item">车辆已行驶里程: {{ formatResultRunDistanceOrMil(routeData) }}</div>
                  <div class="result-item">
                    离线状态:
                    <span
                      class="result-status"
                      :class="bicycleStatusCssClass(routeData)"
                    >{{ formatResultVehicleStatus(routeData) }}</span>
                  </div>
                  <div class="result-item">当前离线时长: {{ formatResultOfflineMinutes(routeData.offlineTime) }}</div>
                </div>
                <div v-else class="result-content">
                  <div class="result-item">请点击查询按钮获取数据</div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!-- 地图弹窗 -->
    <el-dialog :close-on-click-modal="false" title="地图信息" :visible.sync="mapDialogVisible" width="70%" height="50%" @close="onPickerMapDialogClose">
      <div class="map-dialog-content">
        <div class="map-search">
          <el-autocomplete v-model="mapSearchText" :fetch-suggestions="querySearchAsync" placeholder="请输入位置"
            style="width: 18.75rem;" @select="handleSelect" @keyup.enter="searchLocation" popper-append-to-body
            trigger-on-focus :highlight-first-item="true">
            <el-button slot="append" icon="el-icon-search" @click="searchLocation"></el-button>
          </el-autocomplete>
        </div>
        <div ref="mapDialogSlot" class="map-container"></div>
      </div>
      <div style="width: 100%;display: flex;justify-content: flex-end;">
        <el-button style="width: 4.375rem"  type="primary" @click="mapDialogVisible = false" class="search-btn">确定</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import { setAmapSecurityConfig, loadAmapSDK } from "@/utils/amapConfig";
import { tiandituReverseGeocode } from '@/utils/tiandituGeocoder';
import coordtransform from '@/WGS84.js';
import { isLicensePlateFormatValid } from '@/utils/searchFilterValidate';
import { regionData } from 'element-china-area-data';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import LeftJoinGaragePanel from '@/components/LeftJoinGaragePanel.vue'
import PlateLicenseField from '@/components/PlateLicenseField.vue'
import PlateKeyboardInput from '@/components/PlateKeyboardInput.vue'
import VehicleTeamTreePicker from '@/components/business/VehicleTeamTreePicker.vue'
import vehicleDataAutocompleteMixin from '@/mixins/vehicleDataAutocomplete'
import nativePlateColorsMixin from '@/mixins/nativePlateColors'
import { getSearchEndpointPairError } from '@/utils/searchEndpointWarning'
import { BATCH_PLATE_IMPORT_PLACEHOLDER, parseBatchPlateImportText } from '@/utils/vehicleDataList'
import { resolveHeadingDegrees, getDirectionDesc } from '@/utils/vehicleHeading'
import {
  formatGarageVehicleTreeSuffix,
  resolveBicycleDisplayState,
  bicycleStatusTypeFromSts,
  bicycleStatusCssClass,
} from '@/utils/truckLastLocation'
import { isGarageGroupNode } from '@/utils/garageTree'
import { authState, hasPermission } from '@/utils/auth'
import { scopedGet, scopedSet } from '@/utils/scopedLocalStorage'
import { fetchVehicleQuerySelections, addVehicleQuerySelections, removeVehicleQuerySelections } from '@/views/vehicle-monitor/vehicleQuerySelectionsApi'
/* global AMap */

/** 历史查询车辆列表 localStorage 键（仅存车牌、颜色、时间、位置、方向文案） */
const HISTORY_VEHICLE_STORAGE_KEY = 'bicycleHistoryQueryVehicles'
/** 车辆列表（添加监控弹窗、已选同步） */
/** 结果 Tab：查询服务端已选车辆列表 */

export default {
  name: 'LeftJoinBicycle',
  mixins: [vehicleDataAutocompleteMixin, nativePlateColorsMixin],
  components: {
    LeftJoinGaragePanel,
    PlateLicenseField,
    PlateKeyboardInput,
    VehicleTeamTreePicker
  },
  props: {
    isFilterDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * 插件 execType==2 等场景：仅锁定单车筛选区（多车模式不受影响）。
     * 与 isFilterDisabled 叠加时：单车 = 二者任一即禁用；多车 = 仅 isFilterDisabled。
     */
    lockSingleFilters: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 5
    },
    /**
     * true（默认）：始发/目的地与坐标必填，适用于仍走 visualRoute 的页面。
     * false：仅车牌号、车牌颜色必填，适用于插件页 getTruckLastLocation。
     */
    requireRouteFields: {
      type: Boolean,
      default: true
    },
    /**
     * 插件 getPluginParams 仅下发 1 辆 vnos 时：左侧为单车形态，隐藏「单车/多车」切换与「历史查询车辆」页签。
     */
    pluginSingleVnoOnly: {
      type: Boolean,
      default: false
    },
    /** web 后台：展示车库页签，树与增删走 本地只读候选 */
    showGaragePanel: {
      type: Boolean,
      default: false
    },
    garageTreeListUrl: {
      type: String,
      default: ''
    },
    garageTreeListUseRequest: {
      type: Boolean,
      default: false
    },
    garageTreeChildrenUrl: {
      type: String,
      default: ''
    },
    garageTreeChildrenUseRequest: {
      type: Boolean,
      default: false
    },
    vehicleNoRemoteSelect: {
      type: Boolean,
      default: false
    },
    vehicleNoFetchOptions: {
      type: Function,
      default: null
    },
    /** 进入页面时的默认模式：single 单车 | multi 多车 */
    defaultVehicleMode: {
      type: String,
      default: 'single',
      validator: (v) => v === 'single' || v === 'multi'
    }
  },
  data() {
    const initialMode = this.defaultVehicleMode === 'multi' ? 'multi' : 'single'
    return {
      isCollapsed: false,
      vehicleMode: initialMode,
      /** 进入过多车后保留车库实例，切单车再回多车时勾选可回显 */
      multiGarageKeepAlive: initialMode === 'multi',
      /** 默认落在「历史查询车辆」 */
      activeLowerTab: 'history',
      /** 与 LeftJoin 一致：省市区数据源 */
      regionOptions: regionData,
      /** 始发 / 目的 级联选中路径（value 为行政区划编码） */
      selectedAreaOrigin: [],
      selectedAreaDest: [],
      searchForm: {
        licensePlate: '',
        licensePlateColor: '2',
        startAreaCode: '',
        endAreaCode: '',
        originCoord: '',
        destCoord: '',
        originAddress: '',
        destAddress: ''
      },
      // 地图相关
      mapDialogVisible: false,
      mapSearchText: '',
      currentCoordType: '', // 'origin' 或 'dest'
      map: null,
      // 搜索建议
      searchResults: [],
      autoComplete: null, // 添加 autoComplete 实例
      // 接口返回数据
      routeData: null,
      /** 轨迹最后一点无 adr 时，逆地理编码得到的地址（与轨迹明细一致） */
      lastResolvedTrackAddress: '',
      /** 选点地图单例初始化 Promise，防并发重复创建 */
      pickerMapInitPromise: null,
      /** 每次查询成功后合并写入（车牌+颜色去重） */
      historyVehicleList: [],
      historySearchText: '',
      /** 多车筛选：已选车辆（车牌+颜色去重） */
      multiSelectedVehicles: [],
      selectionRequestSequence: 0,
      selectionSaving: false,
      selectionDestroyed: false,
      multiAddDialogVisible: false,
      /** 添加车辆弹窗内动态行 */
      multiAddDraftRows: [],
      /** 批量识别（英文逗号分隔车牌，按位数推断颜色） */
      multiBatchImportVisible: true,
      multiBatchImportText: '',
      batchPlateImportPlaceholder: BATCH_PLATE_IMPORT_PLACEHOLDER,
      /** 添加监控车辆弹窗表格 */
      selectDataList: [],
      selectDataTotal: 0,
      selectDataPage: 1,
      selectDataLimit: 20,
      selectDataContacts: '',
      selectDataLoading: false,
      monitorPickSelectedRows: [],
      /** 多车查询结果：按车牌和颜色区分，定位结果仅保存在内存。 */
      multiVehicleResultList: [],
      resultVehicleSearchText: '',
      lastMultiRefreshAt: null,
      /** 车库树查询结果后缀：车牌_颜色 → [速度 行/停时长 区县] */
      garageVehicleStatusMap: {},
      /** 已选车辆管理弹窗 */
      multiSelectedDialogVisible: false,
      multiSelectedDialogSearch: '',
      /** 已发起过查询的车牌（用于查询状态） */
      multiQueriedPlateMap: {},
      addVehicleDialogVisible: false,
      addVehicleDialogMode: 'create',
      editingVehicleId: '',
      addVehicleForm: {
        parentPath: [],
        vehicleNo: '',
        aliasName: ''
      },
      addVehicleRules: {
        parentPath: [{ required: true, message: '请选择车辆分组', trigger: 'change' }],
        vehicleNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              const plate = value != null ? String(value).trim() : ''
              if (!plate) {
                callback(new Error('请输入车牌号'))
                return
              }
              if (!isLicensePlateFormatValid(plate)) {
                callback(new Error('车牌号格式不正确'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      addVehicleGroupTree: []
    }
  },
  computed: {
    multiAddRowsScrollable() {
      return Array.isArray(this.multiAddDraftRows) && this.multiAddDraftRows.length > 5
    },
    /** 需用 computed，校验器内才可访问 this.searchForm */
    rules() {
      return {
        licensePlate: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              if (!value || !String(value).trim()) {
                callback(new Error('请输入车牌号'))
                return
              }
              if (!isLicensePlateFormatValid(String(value))) {
                callback(new Error('请输入正确格式的车牌号'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        licensePlateColor: [
          { required: true, message: '请选择车牌号颜色', trigger: 'change' }
        ]
      }
    },
    /** runRoute 最后一条轨迹点 */
    lastRunRoutePoint() {
      const r = this.routeData && this.routeData.runRoute
      if (!r || !r.length) return null
      return r[r.length - 1]
    },
    /** 最后一条轨迹点对应时间（gtm） */
    lastTrackTimeDisplay() {
      const p = this.lastRunRoutePoint
      if (!p || !p.gtm) return '-'
      return this.formatTrackGtm(p.gtm)
    },
    /** 最后一条轨迹点地址：点字段优先，其次逆地理，再退回接口顶层 adr */
    lastTrackAddressDisplay() {
      const p = this.lastRunRoutePoint
      if (!p) return '-'
      if (p.adr) return p.adr
      if (p.location) return p.location
      if (this.lastResolvedTrackAddress) return this.lastResolvedTrackAddress
      if (p.lon != null && p.lat != null) return '获取位置中...'
      if (this.routeData && this.routeData.adr) return this.routeData.adr
      return '-'
    },
    /** 单车筛选是否禁用（全局禁用 或 仅锁单车） */
    singleFiltersDisabled() {
      return this.isFilterDisabled || (this.lockSingleFilters && this.vehicleMode === 'single')
    },
    /** 多车筛选是否禁用（不受 lockSingleFilters 影响） */
    multiFiltersDisabled() {
      return this.isFilterDisabled
    },
    monitorSelectDisplayTotal() {
      return Number(this.selectDataTotal) || 0
    },
    monitorSelectPagedList() {
      return Array.isArray(this.selectDataList) ? this.selectDataList : []
    },
    addVehicleGroupTreeOptions() {
      return this.buildGroupTreePickerOptions(this.addVehicleGroupTree)
    },
    /** 历史车辆卡片：单车随 singleFiltersDisabled，多车随 multiFiltersDisabled */
    historyFiltersDisabled() {
      return this.vehicleMode === 'single' ? this.singleFiltersDisabled : this.multiFiltersDisabled
    },
    filteredHistoryVehicleList() {
      const list = Array.isArray(this.historyVehicleList) ? this.historyVehicleList : []
      const q = this.historySearchText != null ? String(this.historySearchText).trim().toLowerCase() : ''
      if (!q) return list
      return list.filter((it) => {
        if (!it || typeof it !== 'object') return false
        const plate = it.vclN != null ? String(it.vclN).toLowerCase() : ''
        const loc = it.locationText != null ? String(it.locationText).toLowerCase() : ''
        return plate.includes(q) || loc.includes(q)
      })
    },
    multiVehicleCardsToShow() {
      const list = Array.isArray(this.multiVehicleResultList) ? this.multiVehicleResultList : []
      const q = this.resultVehicleSearchText != null ? String(this.resultVehicleSearchText).trim().toUpperCase() : ''
      if (!q) return list
      return list.filter((it) => {
        const plate = it && it.vclN != null ? String(it.vclN).toUpperCase() : ''
        return plate.includes(q)
      })
    },
    /** 已选车辆弹窗表格行（合并查询结果字段） */
    multiSelectedDialogTableRows() {
      const selected = Array.isArray(this.multiSelectedVehicles) ? this.multiSelectedVehicles : []
      const q = this.multiSelectedDialogSearch != null
        ? String(this.multiSelectedDialogSearch).trim().toUpperCase()
        : ''
      const resultByPlate = new Map()
      ;(Array.isArray(this.multiVehicleResultList) ? this.multiVehicleResultList : []).forEach((r) => {
        const p = r && r.vclN != null ? String(r.vclN).trim() : ''
        if (p) resultByPlate.set(this.multiSelectedVehicleKey(p, r.vco), r)
      })
      const emptyText = '无'
      return selected
        .filter((v) => {
          if (!v) return false
          if (!q) return true
          const plate = v.vclN != null ? String(v.vclN).toUpperCase() : ''
          return plate.includes(q)
        })
        .map((v) => {
          const plate = v.vclN != null ? String(v.vclN).trim() : ''
          const result = plate ? resultByPlate.get(v._key) : null
          const queried = !!(plate && this.multiQueriedPlateMap[v._key])
          const hasResult = !!(result && result.lon != null && result.lat != null)

          // 未查询：速度/查询状态/行驶状态/离线时间/最后位置统一为「无」
          if (!queried) {
            return {
              _key: v._key,
              vclN: plate || emptyText,
              vco: v.vco,
              spdText: emptyText,
              queryStatusText: '未查询',
              queryStatusType: 'pending',
              statusText: emptyText,
              statusType: '',
              offlineTimeText: emptyText,
              locationText: emptyText
            }
          }

          let queryStatusText = '已查询无结果'
          let queryStatusType = 'empty'
          if (hasResult) {
            queryStatusText = '已查询'
            queryStatusType = 'done'
          }

          const statusText = hasResult
            ? (result.sts ||
              (result.statusType === 'online'
                ? '在线'
                : result.statusType === 'stop'
                  ? '停止'
                  : '离线'))
            : emptyText
          const statusType = hasResult && result.statusType ? result.statusType : ''
          // 与结果卡片一致：用定位相对时间（刚刚 / N天N小时前）
          let offlineTimeText = emptyText
          if (hasResult) {
            if (result.timeLine && result.timeLine !== '—') {
              offlineTimeText = result.timeLine
            } else {
              const locateMs = this.getMultiVehicleLastLocateMs(result)
              const t = locateMs != null ? this.getTime(locateMs) : emptyText
              offlineTimeText = t && t !== '—' ? t : emptyText
            }
          }
          const locationRaw = hasResult ? (result.adr || result.location) : ''
          const locationText =
            locationRaw != null && String(locationRaw).trim() !== '' && String(locationRaw).trim() !== '—'
              ? String(locationRaw).trim()
              : emptyText

          return {
            _key: v._key,
            vclN: plate || emptyText,
            vco: v.vco,
            spdText: hasResult && result.spdText ? result.spdText : emptyText,
            queryStatusText,
            queryStatusType,
            statusText,
            statusType,
            offlineTimeText,
            locationText
          }
        })
    }
  },
  watch: {
    pluginSingleVnoOnly(v) {
      if (v && this.activeLowerTab === 'history') {
        this.activeLowerTab = 'result'
      }
    },
    routeData: {
      handler(val) {
        this.lastResolvedTrackAddress = ''
        this.refreshLastTrackAddress()
        if (this.showGaragePanel && val) {
          this.activeLowerTab = 'result'
        }
      },
      deep: true
    },
    'searchForm.originCoord'() {
      if (!this.map || this.mapDialogVisible) return
      const c = this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      if (!c) return
      this.$nextTick(() => {
        try {
          if (this.map && !this.mapDialogVisible) this.map.setCenter(c)
        } catch (e) {
          console.warn('选点地图同步中心失败', e)
        }
      })
    },
    vehicleMode: {
      immediate: true,
      handler(val) {
        if (val === 'multi') {
          this.multiGarageKeepAlive = true
          if (this.activeLowerTab !== 'result') {
            this.activeLowerTab = 'history'
          }
        }
        this.$emit('vehicle-mode-change', val)
      }
    },
  },
  mounted() {
    this.loadHistoryVehicleListFromStorage()
    this.$nextTick(() => {
      this.ensurePickerMapLoaded().catch((e) => {
        console.warn('选点地图预加载失败，打开弹窗时将重试', e)
      })
    })
  },
  beforeDestroy() {
    this.selectionDestroyed = true
    this.selectionRequestSequence++
    if (this.map) {
      try {
        this.map.destroy()
      } catch (e) {
        /* ignore */
      }
      this.map = null
    }
    this.pickerMapInitPromise = null
  },
  methods: {
    onPlateColorAccountChanged() {
      this.selectionRequestSequence++
      this.selectionSaving = false
      this.searchForm.licensePlate = ''
      this.searchForm.licensePlateColor = '2'
      this.routeData = null
      this.multiSelectedVehicles = []
      this.multiVehicleResultList = []
      this.garageVehicleStatusMap = {}
      this.multiQueriedPlateMap = {}
      this.multiAddDraftRows = []
      this.loadHistoryVehicleListFromStorage()
      if (this.vehicleMode === 'multi') void this.refreshSelectedTbVehiclesFromServer({ suppressTabSwitch: true })
    },
    /** 轨迹点 gtm：yyyymmdd/hhmmss → yyyy-MM-dd hh:mm:ss */
    formatTrackGtm(gtm) {
      if (!gtm || String(gtm).length < 15) return '-'
      try {
        const datePart = gtm.substring(0, 8)
        const timePart = gtm.substring(9)
        if (!datePart || !timePart || timePart.length < 6) return '-'
        const year = datePart.substring(0, 4)
        const month = datePart.substring(4, 6)
        const day = datePart.substring(6, 8)
        const hour = timePart.substring(0, 2)
        const minute = timePart.substring(2, 4)
        const second = timePart.substring(4, 6)
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`
      } catch (e) {
        return '-'
      }
    },
    /** 对轨迹最后一点做逆地理（无 adr/location 时） */
    async refreshLastTrackAddress() {
      const data = this.routeData
      if (!data || !data.runRoute || !data.runRoute.length) return
      const p = data.runRoute[data.runRoute.length - 1]
      if (!p || p.adr || p.location) return
      if (p.lon == null || p.lat == null) return
      try {
        const lonWgs84 = p.lon ? p.lon / 600000.0 : 0
        const latWgs84 = p.lat ? p.lat / 600000.0 : 0
        const [lng, lat] = coordtransform.wgs84togcj02(lonWgs84, latWgs84)
        const r = await tiandituReverseGeocode(lng, lat)
        if (r.success && r.des) {
          this.lastResolvedTrackAddress = r.des
        }
      } catch (e) {
        console.warn('最后轨迹点逆地理失败', e)
      }
    },
    // 切换左侧面板展开/收缩
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
      // 通知父组件状态变化
      this.$emit('toggle', this.isCollapsed)
    },
    multiSelectedVehicleKey(vclN, vco) {
      const p = vclN != null ? String(vclN).trim().toUpperCase() : ''
      const c = vco != null && String(vco).trim() !== '' ? String(vco).trim() : '2'
      return p ? `${p}_${c}` : ''
    },
    createMultiDraftRow() {
      return {
        _rid: `r-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        plate: '',
        vco: this.defaultPlateColor()
      }
    },
    addMultiDraftRow() {
      this.multiAddDraftRows.push(this.createMultiDraftRow())
    },
    removeMultiDraftRow(rid) {
      if (!rid) return
      this.multiAddDraftRows = this.multiAddDraftRows.filter((r) => r._rid !== rid)
    },
    toggleMultiBatchImport() {
      this.multiBatchImportVisible = !this.multiBatchImportVisible
      if (!this.multiBatchImportVisible) {
        this.multiBatchImportText = ''
      }
    },
    parseMultiBatchImportText(text) {
      return parseBatchPlateImportText(text)
    },
    applyMultiBatchRecognize() {
      const list = this.parseMultiBatchImportText(this.multiBatchImportText)
      if (!list.length) {
        this.$message.warning('请输入有效的车牌号')
        return
      }
      if (!Array.isArray(this.multiAddDraftRows)) {
        this.multiAddDraftRows = []
      }
      const existingKeys = new Set(
        this.multiAddDraftRows
          .map((r) => {
            const p = String(r.plate || '').trim()
            const c = String(r.vco != null ? r.vco : '2')
            return p ? this.multiSelectedVehicleKey(p, c) : ''
          })
          .filter(Boolean)
      )
      const emptyRowIndexes = this.multiAddDraftRows
        .map((r, idx) => (!String(r.plate || '').trim() ? idx : -1))
        .filter((idx) => idx >= 0)
      let emptyCursor = 0
      let added = 0
      let skipped = 0
      for (const item of list) {
        const plate = item && item.vclN != null ? String(item.vclN).trim() : ''
        if (!plate) continue
        let vco = item && item.vco != null ? String(item.vco).trim() : '2'
        if (!['1', '2', '3'].includes(vco)) vco = '2'
        const key = this.multiSelectedVehicleKey(plate, vco)
        if (existingKeys.has(key)) {
          skipped += 1
          continue
        }
        existingKeys.add(key)
        if (emptyCursor < emptyRowIndexes.length) {
          const row = this.multiAddDraftRows[emptyRowIndexes[emptyCursor]]
          row.plate = plate
          row.vco = vco
          emptyCursor += 1
        } else {
          this.multiAddDraftRows.push({
            _rid: `r-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
            plate,
            vco
          })
        }
        added += 1
      }
      if (added === 0) {
        this.$message.warning(skipped > 0 ? '识别结果均已在列表中' : '未识别到有效车牌')
        return
      }
      if (skipped > 0) {
        this.$message.success(`已添加 ${added} 条，跳过重复 ${skipped} 条`)
      } else {
        this.$message.success(`已添加 ${added} 条`)
      }
    },
    openMultiAddDialog() {
      this.multiAddDraftRows = [this.createMultiDraftRow()]
      this.multiBatchImportVisible = true
      this.multiBatchImportText = ''
      this.multiAddDialogVisible = true
    },
    onMultiAddDialogClosed() {
      this.multiAddDraftRows = []
      this.multiBatchImportVisible = true
      this.multiBatchImportText = ''
      this.selectDataList = []
      this.selectDataTotal = 0
      this.selectDataPage = 1
      this.selectDataContacts = ''
      this.monitorPickSelectedRows = []
      this.selectDataLoading = false
    },
    async fetchSelectData() { this.selectDataList = []; this.selectDataTotal = 0 },
    onSelectDataSearch() {
      this.selectDataPage = 1
      this.fetchSelectData()
    },
    onSelectDataPageSizeChange(size) {
      const n = Number(size)
      this.selectDataLimit = Number.isFinite(n) && n > 0 ? n : 20
      this.selectDataPage = 1
      this.fetchSelectData()
    },
    onSelectDataPageChange(page) {
      const p = Number(page)
      if (!Number.isFinite(p) || p <= 0) return
      this.selectDataPage = p
      this.fetchSelectData()
    },
    selectDataRowKey(row) {
      if (!row || typeof row !== 'object') return String(Math.random())
      if (row.idStr != null && String(row.idStr).trim() !== '') return String(row.idStr)
      if (row.id != null) return String(row.id)
      const plate = row.vehicleNo != null ? String(row.vehicleNo).trim() : ''
      return plate || `tmp-${Date.now()}-${Math.random()}`
    },
    formatSelectDataAlias(row) {
      const a = row && row.aliasName != null ? String(row.aliasName).trim() : ''
      return a || '无别名'
    },
    onMonitorSelectTableSelectionChange(selection) {
      this.monitorPickSelectedRows = Array.isArray(selection) ? selection : []
    },
    isTbVehicleApiOk(body) {
      if (!body || typeof body !== 'object') return false
      return (
        body.success === true ||
        Number(body.code) === 0 ||
        Number(body.code) === 200 ||
        Number(body.code) === 1
      )
    },
    showTbVehicleApiSuccess(body, fallback) {
      const msg = body && body.msg != null ? String(body.msg).trim() : ''
      this.$message.success(msg || fallback || '操作成功')
    },
    deleteSelectDataVehicleRow() {},
    async confirmMultiAddDialog() {
 const rows = this.multiAddDraftRows.filter(row => String(row.plate || '').trim()).map(row => ({ vclN: String(row.plate).trim().toUpperCase(), vco: String(row.vco || '') }));
 if (!rows.length) return this.$message.warning('请至少填写一条车牌号');
 if (rows.some(row => !this.canSelectPlateColor(row.vco))) return this.$message.warning('请选择正常启用的车牌颜色');
 if (rows.some(row => !isLicensePlateFormatValid(row.vclN) || !['1','2','3'].includes(row.vco))) return this.$message.warning('请填写有效车牌和颜色');
 if (await this.addPlatesToServerSelectedList(rows)) this.multiAddDialogVisible = false
},
    openNestedAddVehicleDialog() {
      void this.handleAddVehicle()
    },
    async ensureAddVehicleGroupTree() { this.addVehicleGroupTree = [] },
    buildGroupTreePickerOptions(nodes) {
      if (!Array.isArray(nodes) || !nodes.length) return []
      return nodes
        .filter((n) => n && isGarageGroupNode(n))
        .map((n) => {
          const name = String(n.teamName || n.name || n.label || '').trim()
          const children = this.buildGroupTreePickerOptions(n.children || [])
          return {
            id: n.id != null ? String(n.id) : '',
            teamName: name.replace(/\s*\[[^\]]*\]\s*$/, '').trim() || name,
            label: n.label || name,
            vehicleCount: n.vehicleCount,
            totalVehicleCount: n.totalVehicleCount,
            children
          }
        })
    },
    findGarageTreeNodeById(nodes, id) {
      if (!Array.isArray(nodes) || id == null) return null
      for (const n of nodes) {
        if (!n || typeof n !== 'object') continue
        if (String(n.id) === String(id)) return n
        const hit = this.findGarageTreeNodeById(n.children || [], id)
        if (hit) return hit
      }
      return null
    },
    resetAddVehicleFields() {
      this.addVehicleForm.parentPath = []
      this.addVehicleForm.vehicleNo = ''
      this.addVehicleForm.aliasName = ''
      if (this.$refs.addVehicleFormRef && typeof this.$refs.addVehicleFormRef.clearValidate === 'function') {
        this.$refs.addVehicleFormRef.clearValidate()
      }
    },
    onAddVehicleDialogClosed() {
      this.addVehicleDialogMode = 'create'
      this.editingVehicleId = ''
      this.resetAddVehicleFields()
    },
    async handleAddVehicle() {
      this.addVehicleDialogMode = 'create'
      this.editingVehicleId = ''
      await this.ensureAddVehicleGroupTree()
      this.addVehicleDialogVisible = true
      this.$nextTick(() => {
        this.resetAddVehicleFields()
      })
    },
    submitAddVehicle() { this.addVehicleDialogVisible = false },
    /**
     * 解析 vnos：鲁Q123GB_2,粤BBA885_3 → [{ vclN, vco }]
     * 颜色取最后一个下划线后的片段（车牌本体不含下划线时成立）
     */
    parseVnosString(vnosStr) {
      const out = []
      for (const seg of String(vnosStr || '').split(',')) {
        const s = seg.trim()
        if (!s) continue
        const last = s.lastIndexOf('_')
        if (last <= 0) {
          out.push({ vclN: s, vco: '2' })
        } else {
          out.push({ vclN: s.slice(0, last), vco: s.slice(last + 1) || '2' })
        }
      }
      return out
    },
    async removeMultiSelected(key) { return this.removePlateFromServerSelectedList(key) },
    openMultiSelectedDialog() {
      if (this.multiFiltersDisabled) return
      this.multiSelectedDialogSearch = ''
      this.multiSelectedDialogVisible = true
    },
    closeMultiSelectedDialog() {
      this.multiSelectedDialogVisible = false
    },
    /** 保存已选车辆修改并关闭弹窗，不触发定位查询 */
    saveMultiSelectedDialog() {
      if (this.selectionSaving) return this.$message.warning('正在保存车辆，请稍后重试')
      this.multiSelectedDialogVisible = false
    },
    /** 保存已选车辆修改、关闭弹窗并重新查询 */
    saveAndQueryMultiSelectedDialog() {
      if (this.selectionSaving) return this.$message.warning('正在保存车辆，请稍后重试')
      this.multiSelectedDialogVisible = false
      this.handleMultiSearch()
    },
    markMultiPlatesQueried(plates) {
      const map = { ...(this.multiQueriedPlateMap || {}) }
      ;(Array.isArray(plates) ? plates : []).forEach((p) => {
        const plate = p != null ? String(p).trim() : ''
        if (plate) map[plate] = true
      })
      this.multiQueriedPlateMap = map
    },
    runGarageMultiQuery(options = {}) {
      if (this.multiFiltersDisabled) return
      this.$nextTick(() => {
        if (!this.multiSelectedVehicles.length) {
          this.clearMultiVehicleQueryResult()
          this.activeLowerTab = 'result'
          this.$emit('search', { vehicleMode: 'multi', vnos: '', mapFocusMode: 'all' })
          return
        }
        this.handleMultiSearch(options)
      })
    },
    handleMultiSearch(options = {}) { if (this.multiFiltersDisabled) return; if (this.multiSelectedVehicles.some(row => !this.canSelectPlateColor(row.vco))) return this.$message.warning('已选车辆包含停用颜色，请调整后查询'); if (this.multiSelectedVehicles.length > 20) return this.$message.warning('每批最多20辆车'); const vnos = this.multiSelectedVehicles.map(v => v.vclN + '_' + v.vco).join(','); this.markMultiPlatesQueried(this.multiSelectedVehicles.map(v => v._key)); this.$emit('search', { vehicleMode: 'multi', vnos, mapFocusMode: options.mapFocusMode || 'all', focusKey: options.focusKey || '' }) },
    toggleMultiSelectedDropdown() {
      /* 已选车辆展开已改为弹窗，保留空实现避免外部调用报错 */
    },
    onMultiSelectedDropdownOutsideClick() {
      /* no-op */
    },
    /** 级联路径 → 取最后一级区县编码作为 startAreaCode / endAreaCode（与 LeftJoin 行为一致） */
    handleAreaOriginChange(val) {
      if (val && val.length) {
        this.searchForm.startAreaCode = String(val[val.length - 1])
      } else {
        this.searchForm.startAreaCode = ''
      }
    },
    handleAreaDestChange(val) {
      if (val && val.length) {
        this.searchForm.endAreaCode = String(val[val.length - 1])
      } else {
        this.searchForm.endAreaCode = ''
      }
    },
    /**
     * 根据任一级别编码在 regionData 中还原级联路径 [省,市,区]
     */
    findRegionPathByCode(targetCode) {
      const t = targetCode != null ? String(targetCode).trim() : ''
      if (!t || !Array.isArray(this.regionOptions)) return []
      const walk = (nodes, stack) => {
        if (!nodes) return null
        for (const n of nodes) {
          const next = [...stack, n.value]
          if (n.value === t) return next
          if (n.children) {
            const found = walk(n.children, next)
            if (found) return found
          }
        }
        return null
      }
      return walk(this.regionOptions, []) || []
    },
    // 处理查询（单车表单；多车使用 handleMultiSearch）
    handleSearch() {
      if (this.singleFiltersDisabled || !this.requirePlateColor(this.searchForm.licensePlateColor)) return
      // 验证表单
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          const endpointError = getSearchEndpointPairError({
            startAreaCode: this.searchForm.startAreaCode,
            endAreaCode: this.searchForm.endAreaCode,
            startAddress: this.searchForm.originAddress,
            endAddress: this.searchForm.destAddress,
            startLonlat: this.searchForm.originCoord,
            endLonlat: this.searchForm.destCoord
          })
          if (endpointError) return this.$message.warning(endpointError)
          const params = {
            vclN: this.searchForm.licensePlate,
            vco: this.searchForm.licensePlateColor,
            qryBtm: '',
            qryEtm: '',
            startLonlat: this.normalizeCoordStrToSixDecimals(this.searchForm.originCoord),
            endLonlat: this.normalizeCoordStrToSixDecimals(this.searchForm.destCoord),
            startAreaCode: this.searchForm.startAreaCode,
            endAreaCode: this.searchForm.endAreaCode,
            parkMins: '',
            vehicleMode: this.vehicleMode,
            checkedVehicleIds:
              this.$refs.vehicleTree && typeof this.$refs.vehicleTree.getCheckedKeys === 'function'
                ? this.$refs.vehicleTree.getCheckedKeys(true)
                : []
          }
          this.activeLowerTab = 'result'
          this.$emit('search', params)
        } else {
          return false;
        }
      });
    },
    /** 解析「lng,lat」或「lng lat」坐标串，失败返回 null */
    parseLngLatFromCoordStr(str) {
      if (str == null || String(str).trim() === '') return null
      const s = String(str).trim().replace(/\s+/g, ',')
      const parts = s.split(',').map((x) => parseFloat(x.trim())).filter((n) => Number.isFinite(n))
      if (parts.length < 2) return null
      const [lng, lat] = parts
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return null
      return [lng, lat]
    },
    /** 点击查询 emit 用：经纬度格式化为小数点后 6 位 */
    normalizeCoordStrToSixDecimals(str) {
      if (str == null) return ''
      const trimmed = String(str).trim()
      if (!trimmed) return ''
      const pair = this.parseLngLatFromCoordStr(trimmed)
      if (!pair) return trimmed
      const [lng, lat] = pair
      return `${Number(lng).toFixed(6)},${Number(lat).toFixed(6)}`
    },
    /** 预加载/选点地图中心：优先始发地坐标 */
    getPickerMapCenterFromForm() {
      return this.parseLngLatFromCoordStr(this.searchForm.originCoord) || [116.404, 39.915]
    },
    applyMapCenterForPickType(type) {
      if (!this.map) return
      let c = null
      if (type === 'dest') {
        c = this.parseLngLatFromCoordStr(this.searchForm.destCoord) ||
          this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      } else {
        c = this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      }
      const center = c || [116.404, 39.915]
      try {
        this.map.setZoomAndCenter(15, center, true)
      } catch (e) {
        console.warn('选点地图设置中心失败', e)
      }
    },
    getCoordLngLatForPickerType(type) {
      if (type === 'dest') {
        const d = this.parseLngLatFromCoordStr(this.searchForm.destCoord)
        if (d) return d
        return this.parseLngLatFromCoordStr(this.searchForm.originCoord)
      }
      return this.parseLngLatFromCoordStr(this.searchForm.originCoord)
    },
    syncPickerMapWithFormCoords(type) {
      if (!this.map) return
      try {
        this.map.clearMap()
      } catch (e) {
        console.warn('选点地图 clearMap 失败', e)
      }
      this.applyMapCenterForPickType(type)
      const pos = this.getCoordLngLatForPickerType(type)
      if (pos && window.AMap) {
        try {
          new AMap.Marker({
            position: pos,
            map: this.map
          })
        } catch (e) {
          console.warn('选点地图标记失败', e)
        }
      }
    },
    attachPickerMapToDialog() {
      const slot = this.$refs.mapDialogSlot
      const el = this.$refs.mapSingletonEl
      if (!slot || !el) return
      if (el.parentNode !== slot) slot.appendChild(el)
    },
    onPickerMapDialogClose() {
      const wrap = this.$refs.mapPrewarmWrap
      const el = this.$refs.mapSingletonEl
      if (this.map && wrap && el && el.parentNode !== wrap) {
        wrap.appendChild(el)
        this.$nextTick(() => {
          try {
            if (this.map) this.map.resize()
          } catch (e) {
            console.warn('选点地图 resize 失败', e)
          }
        })
      }
    },
    async ensurePickerMapLoaded() {
      if (this.map) return
      if (!this.pickerMapInitPromise) {
        this.pickerMapInitPromise = this.createPickerMapOnce().catch((err) => {
          this.pickerMapInitPromise = null
          throw err
        })
      }
      await this.pickerMapInitPromise
    },
    async createPickerMapOnce() {
      await this.$nextTick()
      let retries = 10
      while (!this.$refs.mapSingletonEl && retries-- > 0) {
        await new Promise((r) => setTimeout(r, 50))
      }
      const container = this.$refs.mapSingletonEl
      if (!container) throw new Error('地图容器未就绪')

      setAmapSecurityConfig()
      await loadAmapSDK([
        'AMap.Geocoder',
        'AMap.PlaceSearch',
        'AMap.MouseTool',
        'AMap.CircleEditor',
        'AMap.PolygonEditor',
        'AMap.MarkerCluster',
        'AMap.GeometryUtil',
        'AMap.Scale',
        'AMap.ToolBar',
        'AMap.AutoComplete'
      ])

      const center = this.getPickerMapCenterFromForm()
      this.map = new AMap.Map(container, {
        zoom: 11,
        center,
        resizeEnable: true,
        mapStyle: 'amap://styles/6e581a480732b7393cf1f6f02c9c4c5a',
        zooms: [3, 16],
        features: ['point', 'road', 'building', 'boundary']
      })
      this.map.addControl(new AMap.ToolBar())
      this.map.on('click', (e) => {
        const lng = e.lnglat.getLng()
        const lat = e.lnglat.getLat()
        this.getAddress(lng, lat)
      })
      this.initAutoComplete()
    },
    // 打开地图弹窗（复用单例地图，仅移动 DOM + resize）
    openMapDialog(type) {
      if (this.singleFiltersDisabled) return
      this.currentCoordType = type
      this.mapDialogVisible = true
      this.$nextTick(async () => {
        try {
          await this.ensurePickerMapLoaded()
          this.attachPickerMapToDialog()
          await this.$nextTick()
          try {
            if (this.map) this.map.resize()
          } catch (e) {
            console.warn('选点地图 resize 失败', e)
          }
          this.syncPickerMapWithFormCoords(type)
        } catch (error) {
          console.error('地图加载失败:', error)
          this.$message.error('地图加载失败，请刷新重试')
        }
      })
    },
    // 初始化 AutoComplete
    initAutoComplete() {
      if (window.AMap) {
        AMap.plugin('AMap.AutoComplete', () => {
          this.autoComplete = new AMap.AutoComplete({
            city: '全国',
            citylimit: false
            // ⚠️ 注意：这里千万不要传 securityJsCode
          });
        });
      }
    },
    // 模糊查询（修改后的版本）
    querySearchAsync(queryString, callback) {
      if (!queryString) {
        callback([]);
        return;
      }

      // 确保 AMap 已加载
      if (!window.AMap) {
        callback([]);
        return;
      }

      // 使用 AMap.plugin 加载 AutoComplete 插件
      AMap.plugin('AMap.AutoComplete', () => {
        this.performSearch(queryString, callback);
      });
    },
    // 执行搜索
    performSearch(queryString, callback) {
      if (!window.AMap) {
        callback([]);
        return;
      }

      // 每次查询都创建新的实例
      const auto = new AMap.AutoComplete({
        city: '全国',
        citylimit: false
        // ⚠️ 注意：这里千万不要传 securityJsCode
      });

      auto.search(queryString, (status, result) => {
        console.log('AutoComplete 搜索状态:', status, queryString);
        console.log('AutoComplete 搜索结果:', result);

        if (status === 'complete' && result.info === 'OK' && result.tips) {
          const suggestions = result.tips
            .filter(tip => tip.location)
            .map(tip => ({
              value: tip.name,
              address: tip.district + (tip.address || ''),
              location: tip.location,
              _raw: tip
            }))
            .slice(0, 10);

          console.log('搜索建议:', suggestions);
          callback(suggestions);
        } else {
          console.log('搜索失败:', status, result);
          callback([]);
        }
      });
    },

    // 处理选择搜索建议（修改以支持新格式）
    handleSelect(item) {
      this.mapSearchText = item.value;

      // 如果有位置信息
      if (item.location) {
        // 处理 location 可能是字符串 "lng,lat" 或对象的情况
        let lng, lat;

        if (typeof item.location === 'string') {
          const coords = item.location.split(',');
          lng = parseFloat(coords[0]);
          lat = parseFloat(coords[1]);
        } else if (item.location.lng && item.location.lat) {
          lng = item.location.lng;
          lat = item.location.lat;
        }

        if (lng && lat) {
          // 移动地图到选择的位置
          this.map.setZoomAndCenter(15, [lng, lat], true);

          const coord = `${lng},${lat}`;
          if (this.currentCoordType === 'origin') {
            this.searchForm.originCoord = coord;
            this.searchForm.originAddress = item.value || item.address || '';
          } else if (this.currentCoordType === 'dest') {
            this.searchForm.destCoord = coord;
            this.searchForm.destAddress = item.value || item.address || '';
          }

          // 在地图上添加标记
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: item.value,
            map: this.map
          });

          return;
        }
      }

      // 如果没有位置信息，调用搜索方法
      this.searchLocation();
    },
    // 根据经纬度获取地址
    getAddress(lng, lat) {
      const coord = `${lng},${lat}`;

      // 根据当前操作类型更新坐标
      if (this.currentCoordType === 'origin') {
        this.searchForm.originCoord = coord;
      } else if (this.currentCoordType === 'dest') {
        this.searchForm.destCoord = coord;
      }

      tiandituReverseGeocode(lng, lat).then((r) => {
        if (r.success && r.des) {
          const address = r.des;
          if (this.currentCoordType === 'origin') this.searchForm.originAddress = address;
          if (this.currentCoordType === 'dest') this.searchForm.destAddress = address;
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: address,
            map: this.map
          });
          this.$message.success(`已选择坐标: ${coord}`);
        } else {
          this.$message.warning('获取地址失败');
        }
      });
    },
    // 搜索位置
    searchLocation() {
      if (!this.mapSearchText || !window.AMap) return;

      const geocoder = new AMap.Geocoder({
        // Geocoder 不需要传安全密钥
      });

      geocoder.getLocation(this.mapSearchText, (status, result) => {
        if (status === 'complete' && result.geocodes && result.geocodes.length > 0) {
          const location = result.geocodes[0].location;
          const lng = location.getLng();
          const lat = location.getLat();

          // 移动地图到搜索位置
          this.map.setZoomAndCenter(15, [lng, lat], true);

          // 在地图上添加标记
          this.map.clearMap();
          new AMap.Marker({
            position: [lng, lat],
            title: this.mapSearchText,
            map: this.map
          });

          // 更新坐标输入框
          const coord = `${lng},${lat}`;
          if (this.currentCoordType === 'origin') {
            this.searchForm.originCoord = coord;
            this.searchForm.originAddress = this.mapSearchText;
          } else if (this.currentCoordType === 'dest') {
            this.searchForm.destCoord = coord;
            this.searchForm.destAddress = this.mapSearchText;
          }

        } else {
          this.$message.warning('未找到该位置');
        }
      });
    },
    /** 单车结果：预计到达，无值时显示「-」 */
    formatResultEstimateTime(timestamp) {
      if (timestamp == null || timestamp === '') return '-'
      const date = new Date(timestamp)
      if (Number.isNaN(date.getTime())) return '-'
      return date.toLocaleString('zh-CN')
    },
    /** 单车结果：公里类数值 */
    formatResultKm(val) {
      if (val == null || val === '') return '-'
      const n = Number(val)
      if (!Number.isFinite(n)) return `${val} km`
      return `${n} km`
    },
    /**
     * 已行驶里程：优先 runDistance，为空时用接口 mil（总里程）
     */
    formatResultRunDistanceOrMil(rd) {
      if (!rd) return '-'
      const run = rd.runDistance
      if (run != null && run !== '') {
        const n = Number(run)
        return Number.isFinite(n) ? `${n} km` : `${run} km`
      }
      const mil = rd.mil
      if (mil != null && mil !== '') {
        const n = Number(mil)
        return Number.isFinite(n) ? `${n.toFixed(2)} km` : `${mil} km`
      }
      return '-'
    },
    formatResultOfflineMinutes(min) {
      if (min == null || min === '') return '-'
      return `${min} 分钟`
    },
    formatResultVehicleStatus(rd) {
      return resolveBicycleDisplayState(rd)
    },
    bicycleStatusCssClass,
    // 格式化方向
    formatDirection(drc) {
      if (!drc && drc !== 0) return '未知';
      if (drc === 0) return '正北';
      if (drc > 0 && drc < 90) return '东北';
      if (drc === 90) return '正东';
      if (drc > 90 && drc < 180) return '东南';
      if (drc === 180) return '正南';
      if (drc > 180 && drc < 270) return '西南';
      if (drc === 270) return '正西';
      if (drc > 270 && drc <= 359) return '西北';
      return '未知';
    },
    /** 车牌 + 颜色 → 去重键 */
    historyVehicleRowKey(row) {
      const plate = row && row.vclN != null ? String(row.vclN).trim() : ''
      const vco = row && row.vco != null ? String(row.vco) : ''
      return plate ? `${plate}_${vco}` : ''
    },
    /** gtm yyyymmdd/hhmmss → 展示用 */
    formatGtmDisplay(gtm) {
      if (!gtm || String(gtm).length < 15) return '—'
      try {
        const datePart = gtm.substring(0, 8)
        const timePart = gtm.substring(9)
        return `${datePart.substring(0, 4)}-${datePart.substring(4, 6)}-${datePart.substring(6, 8)} ${timePart.substring(0, 2)}:${timePart.substring(2, 4)}:${timePart.substring(4, 6)}`
      } catch (e) {
        return '—'
      }
    },
    gtmStringToMs(gtm) {
      if (!gtm || String(gtm).length < 15) return 0
      try {
        const datePart = gtm.substring(0, 8)
        const timePart = gtm.substring(9)
        const d = new Date(
          `${datePart.substring(0, 4)}-${datePart.substring(4, 6)}-${datePart.substring(6, 8)}T${timePart.substring(0, 2)}:${timePart.substring(2, 4)}:${timePart.substring(4, 6)}`
        )
        const t = d.getTime()
        return Number.isNaN(t) ? 0 : t
      } catch (e) {
        return 0
      }
    },
    /** 与 bicyclePlugins formatDirectionText 一致，用于历史卡片方向行 */
    formatDirectionTextForHistory(item) {
      if (!item) return '—'
      const deg = resolveHeadingDegrees(item)
      if (deg != null) return getDirectionDesc(deg) || '—'
      return item.agl != null && item.agl !== '' ? String(item.agl) : '—'
    },
    normalizeHistoryVehicleRow(row) {
      const vclN = row.vclN != null ? String(row.vclN).trim() : ''
      const vco = row.vco != null ? String(row.vco) : '2'
      const gtm = row.gtm
      const lastTimeText = this.formatGtmDisplay(gtm)
      const rawLoc = row.adr != null && String(row.adr).trim() !== '' ? String(row.adr).trim() : row.location
      const locationText = rawLoc != null && String(rawLoc).trim() !== '' ? String(rawLoc).trim() : '—'
      const directionText = this.formatDirectionTextForHistory(row)
      const lastTimeMs = this.gtmStringToMs(gtm)
      const _key = vclN ? `${vclN}_${vco}` : ''
      return {
        vclN: vclN || '—',
        vco,
        gtm: gtm || '',
        lon: row && row.lon != null ? row.lon : null,
        lat: row && row.lat != null ? row.lat : null,
        raw: row && row.raw ? row.raw : row,
        lastTimeText,
        locationText,
        directionText,
        lastTimeMs,
        _key
      }
    },
    loadHistoryVehicleListFromStorage() {
      try {
        const scope = this.$route && this.$route.path
        const rows = JSON.parse(scopedGet(HISTORY_VEHICLE_STORAGE_KEY, scope) || '[]')
        this.historyVehicleList = Array.isArray(rows) ? rows.filter(row => row && row.vclN && ['1', '2', '3'].includes(String(row.vco))) : []
      } catch (error) {
        this.historyVehicleList = []
      }
    },
    persistHistoryVehicleList() {
      const rows = this.historyVehicleList.map(row => ({
        vclN: row.vclN, vco: row.vco, gtm: row.gtm, lon: row.lon, lat: row.lat,
        lastTimeText: row.lastTimeText, locationText: row.locationText,
        directionText: row.directionText, lastTimeMs: row.lastTimeMs, _key: row._key
      }))
      scopedSet(HISTORY_VEHICLE_STORAGE_KEY, JSON.stringify(rows), this.$route && this.$route.path)
    },
    /**
     * 父页面在每次查询成功拿到车辆行后调用；按车牌+颜色去重，新记录覆盖旧记录，按最后定位时间倒序
     * @param {Array<Object>} rows — 含 vclN、vco、gtm、adr/location、drc/agl
     */
    mergeHistoryFromQueryRows(rows) {
      if (!Array.isArray(rows) || !rows.length) return
      const byKey = new Map()
      this.historyVehicleList.forEach((item) => {
        const k = item._key || this.historyVehicleRowKey(item)
        if (k) byKey.set(k, { ...item })
      })
      rows.forEach((row) => {
        const rec = this.normalizeHistoryVehicleRow(row)
        if (!rec._key) return
        byKey.set(rec._key, rec)
      })
      const merged = Array.from(byKey.values())
      merged.sort((a, b) => (b.lastTimeMs || 0) - (a.lastTimeMs || 0))
      this.historyVehicleList = merged
      this.persistHistoryVehicleList()
    },
    async fetchVehicleNoRemoteOptions(contacts) {
      if (this.vehicleDataAutocomplete) {
        return this.fetchVehicleNoFromDataList(contacts)
      }
      if (!this.vehicleNoFetchOptions) return []
      try {
        const list = await this.vehicleNoFetchOptions(contacts)
        return Array.isArray(list) ? list : []
      } catch (e) {
        console.error('vehicleNoFetchOptions error', e)
        return []
      }
    },
    async onGarageApplyVehicle({ vclN, vco }) { if (!this.requirePlateColor(vco)) return; if (this.vehicleMode === 'multi') { await this.addPlatesToServerSelectedList([{ vclN, vco }]); return } this.searchForm.licensePlate = vclN; this.searchForm.licensePlateColor = String(vco) },
    /** 点击历史记录：单车=直接查询；多车=仅地图定位，不加入已选列表 */
    onHistoryVehicleClick(item) {
      if (this.historyFiltersDisabled) return
      if (this.vehicleMode === 'multi') {
        if (item && item.lon != null && item.lat != null) {
          this.$emit('history-locate-on-map', item)
        } else {
          this.$message.warning('该条历史无有效经纬度')
        }
        return
      }
      if (item && item.lon != null && item.lat != null) {
        this.$emit('history-locate-on-map', item)
      }
      const plate = item && item.vclN && String(item.vclN).trim() !== '' && item.vclN !== '—' ? String(item.vclN).trim() : ''
      if (!plate) {
        this.$message.warning('无法识别该条历史车牌')
        return
      }

      // 单车模式：点击即查询
      this.vehicleMode = 'single'
      this.searchForm.licensePlate = plate
      this.searchForm.licensePlateColor = String(item.vco != null && item.vco !== '' ? item.vco : '2')
      this.$nextTick(() => {
        try {
          if (this.$refs.searchForm && typeof this.$refs.searchForm.clearValidate === 'function') {
            this.$refs.searchForm.clearValidate()
          }
        } catch (e) {
          /* ignore */
        }
        this.handleSearch()
      })
    },
    onDeleteHistoryVehicle(item) {
      if (this.historyFiltersDisabled) return
      const key = item && (item._key || this.historyVehicleRowKey(item))
      if (!key) return
      this.historyVehicleList = this.historyVehicleList.filter((it) => {
        const k = it && (it._key || this.historyVehicleRowKey(it))
        return k !== key
      })
      this.persistHistoryVehicleList()
    },
    onClearHistoryVehicles() {
      if (this.historyFiltersDisabled || !this.historyVehicleList.length) return
      this.historyVehicleList = []
      this.persistHistoryVehicleList()
    },
    pad2(n) {
      return String(n).padStart(2, '0')
    },
    parseSpdKm(row) { const raw = row && (row.spd !== undefined ? row.spd : row.speed); return raw != null && raw !== '' && Number.isFinite(Number(raw)) && Number(raw) >= 0 ? Number(raw) : null },
    formatGtmTimeShort(gtm) {
      if (!gtm || String(gtm).length < 15) return '—'
      try {
        const timePart = gtm.substring(9)
        return `${timePart.substring(0, 2)}:${timePart.substring(2, 4)}`
      } catch (e) {
        return '—'
      }
    },
    /** 定位时间毫秒：优先 raw.utc / utc，否则 gtm 串 */
    getMultiVehicleLastLocateMs(row) {
      if (!row) return null
      const raw = row.raw || {}
      const utc = raw.utc != null && raw.utc !== '' ? raw.utc : row.utc
      if (utc != null && utc !== '') {
        let ms = Number(utc)
        if (!Number.isFinite(ms)) return null
        if (ms < 1e12) ms *= 1000
        return ms
      }
      if (row.gtm && String(row.gtm).length >= 15) return this.gtmStringToMs(row.gtm)
      return null
    },
    dataParse(time) {
      const t = parseFloat(time)
      if (!Number.isFinite(t)) return '—'
      const date = new Date(t)
      if (Number.isNaN(date.getTime())) return '—'
      const padZero = (num) => (num < 10 ? '0' + num : String(num))
      return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`
    },
    /** 相对定位时间：刚刚 / N分钟前 / … / 超过约 30 天则绝对时间 */
    getTime(timeValue) {
      const timestamp = parseFloat(timeValue)
      if (!Number.isFinite(timestamp)) return '—'
      const now = Date.now()
      const diff = now - timestamp
      if (diff < 0) return this.dataParse(timestamp)
      const minute = 60 * 1000
      const hour = 60 * minute
      const day = 24 * hour
      const month = 30 * day
      if (diff <= 5 * minute) return '刚刚'
      if (diff < hour) {
        const minutesAgo = Math.floor(diff / minute)
        return `${minutesAgo}分钟前`
      }
      if (diff < day) {
        const hoursAgo = Math.floor(diff / hour)
        const minutesAgo = Math.floor((diff % hour) / minute)
        return `${hoursAgo}小时${minutesAgo}分钟前`
      }
      if (diff < month) {
        const daysAgo = Math.floor(diff / day)
        const hoursAgo = Math.floor((diff % day) / hour)
        const minutesAgo = Math.floor(((diff % day) % hour) / minute)
        return `${daysAgo}天${hoursAgo}小时${minutesAgo}分钟前`
      }
      return this.dataParse(timeValue)
    },
    buildMultiVehicleDisplayItem(row) {
      const vclN = row.vclN != null ? String(row.vclN).trim() : '—'
      const vco = row.vco != null ? String(row.vco) : '2'
      const raw = row.raw || {}
      const aliasCand = [raw.alias, raw.driverName, raw.nickName, raw.name, raw.driver]
      const alias = aliasCand.find((x) => x != null && String(x).trim() !== '')
      const aliasText = alias ? String(alias).trim() : '无别名'
      const spdNum = this.parseSpdKm(row)
      const spdText = spdNum == null ? '未知' : `${spdNum.toFixed(spdNum % 1 === 0 ? 0 : 1)} km/h`
      const statusText = this.parseSpdKm(row) == null ? '未知' : resolveBicycleDisplayState(row)
      const statusType = bicycleStatusTypeFromSts(statusText)
      const locateMs = this.getMultiVehicleLastLocateMs(row)
      const timeLine = locateMs != null ? this.getTime(locateMs) : '—'
      const timeShort = this.formatGtmTimeShort(row.gtm)
      const adr =
        (row.adr != null && String(row.adr).trim() !== '' ? String(row.adr).trim() : '') ||
        (row.location != null && String(row.location).trim() !== '' ? String(row.location).trim() : '') ||
        (raw.adr != null && String(raw.adr).trim() !== '' ? String(raw.adr).trim() : '') ||
        (raw.address != null && String(raw.address).trim() !== '' ? String(raw.address).trim() : '') ||
        (raw.location != null && String(raw.location).trim() !== '' ? String(raw.location).trim() : '')
      const offlineTime =
        row.offlineTime != null && row.offlineTime !== ''
          ? row.offlineTime
          : raw.offlineTime != null && raw.offlineTime !== ''
            ? raw.offlineTime
            : null
      // 组合身份保证同牌不同颜色分别显示。
      const _key = vclN && vclN !== '—' ? this.multiSelectedVehicleKey(vclN, vco) : ''
      return {
        _key,
        vclN,
        vco,
        lon: row && row.lon != null ? row.lon : null,
        lat: row && row.lat != null ? row.lat : null,
        adr,
        location: adr,
        offlineTime,
        sts: statusText,
        raw: row && row.raw ? row.raw : row,
        aliasText,
        spdText,
        timeLine,
        timeShort,
        statusType
      }
    },
    onResultVehicleCardClick(item) {
      if (!item || item.lon == null || item.lat == null) return
      this.$emit('result-locate-on-map', item)
    },
    /** 多车查询成功：按车牌和颜色写入当前结果列表。 */
    setMultiVehicleQueryResult(rows) {
      if (!Array.isArray(rows) || !rows.length) {
        this.multiVehicleResultList = []
        this.garageVehicleStatusMap = {}
        this.lastMultiRefreshAt = Date.now()
        return
      }
      const map = new Map()
      const statusMap = {}
      rows.forEach((r) => {
        const item = this.buildMultiVehicleDisplayItem(r)
        if (item._key) map.set(item._key, item)
        if (item._key) statusMap[item._key] = formatGarageVehicleTreeSuffix(r)
      })
      this.multiVehicleResultList = Array.from(map.values())
      this.garageVehicleStatusMap = statusMap
      this.lastMultiRefreshAt = Date.now()
      this.$nextTick(() => {
        const gp = this.$refs.garagePanel
        if (gp && typeof gp.refreshTreeDisplay === 'function') gp.refreshTreeDisplay()
      })
    },
    queryResultVehicleSuggestions(queryString, callback) {
      const q = queryString != null ? String(queryString).trim().toUpperCase() : ''
      const source = Array.isArray(this.multiVehicleResultList) ? this.multiVehicleResultList : []
      const opts = source
        .filter((it) => {
          const plate = it && it.vclN != null ? String(it.vclN).toUpperCase() : ''
          return !q || plate.includes(q)
        })
        .slice(0, 20)
        .map((it) => ({ value: String(it.vclN || '') }))
      callback(opts)
    },
    onResultVehicleSearchInput(value) {
      this.resultVehicleSearchText = value != null ? String(value) : ''
    },
    onResultVehicleSelect(item) {
      this.resultVehicleSearchText = item && item.value != null ? String(item.value) : ''
    },
    onResultVehicleClear() {
      this.resultVehicleSearchText = ''
    },
    clearMultiVehicleQueryResult() {
      this.multiVehicleResultList = []
      this.garageVehicleStatusMap = {}
      this.lastMultiRefreshAt = null
      this.multiQueriedPlateMap = {}
    },
    normalizeSelectedVehicleFromApi(item) {
      if (!item || typeof item !== 'object') return null
      const vclN = String(item.vehicleNo || item.vclN || '').trim().toUpperCase()
      const vco = String(item.plateColor != null ? item.plateColor : item.vehiclePlateColor != null ? item.vehiclePlateColor : item.vco || '')
      if (!vclN || !['1', '2', '3'].includes(vco)) return null
      return { vclN, vco, raw: item }
    },
    applySelectedTbVehiclesFromApi(apiList, options = {}) {
      if (!Array.isArray(apiList)) return
      const rows = new Map()
      apiList.forEach(item => {
        const row = this.normalizeSelectedVehicleFromApi(item)
        if (row) rows.set(this.multiSelectedVehicleKey(row.vclN, row.vco), row)
      })
      const previous = new Map(this.multiVehicleResultList.map(row => [row._key, row]))
      this.multiSelectedVehicles = Array.from(rows, ([_key, row]) => ({ vclN: row.vclN, vco: row.vco, _key }))
      this.multiVehicleResultList = Array.from(rows, ([key, row]) => previous.get(key) || this.buildMultiVehicleDisplayItem(row))
      const statuses = {}, queried = {}
      rows.forEach((row, key) => {
        if (this.garageVehicleStatusMap[key] != null) statuses[key] = this.garageVehicleStatusMap[key]
        if (this.multiQueriedPlateMap[key]) queried[key] = true
      })
      this.garageVehicleStatusMap = statuses
      this.multiQueriedPlateMap = queried
      this.lastMultiRefreshAt = Date.now()
      if (!options.suppressTabSwitch) this.activeLowerTab = 'result'
      this.restoreGarageCheckedFromSelected()
    },
    canManageVehicleSelections() {
      return Boolean(authState.user && (hasPermission('truck:position') || hasPermission('truck:track')))
    },
    isVehicleSelectionRequestCurrent(sequence, actor) {
      return !this.selectionDestroyed && sequence === this.selectionRequestSequence && actor === authState.user && this.canManageVehicleSelections()
    },
    async refreshSelectedTbVehiclesFromServer(options = {}) {
      if (!this.canManageVehicleSelections() || this.selectionSaving || this.selectionDestroyed) return false
      const actor = authState.user, sequence = ++this.selectionRequestSequence
      try {
        const rows = await fetchVehicleQuerySelections()
        if (!this.isVehicleSelectionRequestCurrent(sequence, actor)) return false
        this.applySelectedTbVehiclesFromApi(rows, options)
        return true
      } catch (error) {
        if (this.isVehicleSelectionRequestCurrent(sequence, actor)) this.$message.error(error.msg || error.message || '已选车辆加载失败')
        return false
      }
    },
    async saveVehicleSelections(vehicles, remove) {
      if (!this.canManageVehicleSelections() || this.selectionDestroyed) return false
      if (this.selectionSaving) { this.$message.warning('正在保存车辆，请稍后重试'); return false }
      const actor = authState.user, sequence = ++this.selectionRequestSequence
      this.selectionSaving = true
      try {
        const rows = await (remove ? removeVehicleQuerySelections(vehicles) : addVehicleQuerySelections(vehicles))
        if (!this.isVehicleSelectionRequestCurrent(sequence, actor)) return false
        this.applySelectedTbVehiclesFromApi(rows)
        return true
      } catch (error) {
        if (this.isVehicleSelectionRequestCurrent(sequence, actor)) this.$message.error(error.msg || error.message || '已选车辆保存失败')
        return false
      } finally {
        if (!this.selectionDestroyed && sequence === this.selectionRequestSequence && actor === authState.user) this.selectionSaving = false
      }
    },
    async postAddSelectedVehiclesAfterLocate() {
      return this.addPlatesToServerSelectedList(this.multiSelectedVehicles)
    },
    syncGarageTreeCheckedPlates() { this.restoreGarageCheckedFromSelected() },
    /** 按牌色组合身份回显勾选，不会把另一种颜色一起勾选。 */
    restoreGarageCheckedFromSelected() { this.$nextTick(() => { const gp = this.$refs.garagePanel; const tree = gp && gp.$refs.garageVehicleTree; if (tree) tree.setCheckedKeys(this.multiSelectedVehicles.map(row => 'v-' + row._key)) }) },
    onGarageTreeLoaded() { this.restoreGarageCheckedFromSelected() },
    async addPlatesToServerSelectedList(vehicles) {
      const existing = new Set(this.multiSelectedVehicles.map(row => row._key))
      const requested = new Map()
      for (const item of vehicles || []) {
        const row = this.normalizeSelectedVehicleFromApi(item)
        if (!row || !isLicensePlateFormatValid(row.vclN)) { this.$message.warning('请填写有效车牌和颜色'); return false }
        const key = this.multiSelectedVehicleKey(row.vclN, row.vco)
        if (!existing.has(key) && !this.canSelectPlateColor(row.vco)) { this.$message.warning('请选择正常启用的车牌颜色'); return false }
        requested.set(key, { vehicleNo: row.vclN, plateColor: row.vco })
      }
      if (!requested.size) return false
      const total = new Set([...existing, ...requested.keys()]).size
      if (requested.size > 20 || total > 20) { this.$message.warning('已选车辆最多20辆'); return false }
      return this.saveVehicleSelections(Array.from(requested.values()), false)
    },
    async removePlateFromServerSelectedList(key) { return this.removePlatesFromServerSelectedList([key]) },
    async removePlatesFromLocalMultiList(keys) { return this.removePlatesFromServerSelectedList(keys) },
    async removePlatesFromServerSelectedList(keys) {
      const wanted = new Set(keys || [])
      const vehicles = this.multiSelectedVehicles.filter(row => wanted.has(row._key))
        .map(row => ({ vehicleNo: row.vclN, plateColor: row.vco }))
      if (!vehicles.length) return true
      return this.saveVehicleSelections(vehicles, true)
    },
    async onGarageVehicleCheckChange(payload) {
      if (!payload || this.vehicleMode !== 'multi') return
      const rows = payload.vehicles || []
      const saved = payload.checked
        ? await this.addPlatesToServerSelectedList(rows)
        : await this.removePlatesFromServerSelectedList(rows.map(row => this.multiSelectedVehicleKey(row.vclN, row.vco)))
      if (!saved) this.restoreGarageCheckedFromSelected()
    },
    async removeMultiVehicleItem(key) { return this.removePlateFromServerSelectedList(key) },
    async onClearAllMultiVehicles() {
      if (!this.multiSelectedVehicles.length) return
      const actor = authState.user
      const keys = this.multiSelectedVehicles.map(row => row._key)
      try {
        await this.$confirm('确定清空已选车辆列表？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
      } catch (error) { return }
      if (actor !== authState.user || this.selectionDestroyed) return
      await this.removePlatesFromServerSelectedList(keys)
    },
    // onMultiImportPlaceholder() {
    //   this.$message.info('导入功能待接入')
    // },
    onMultiExportIn() {
      if (this.multiFiltersDisabled) return
      if (this.$refs.multiImportInput && typeof this.$refs.multiImportInput.click === 'function') {
        this.$refs.multiImportInput.click()
      }
    },
    async onMultiImportFileChange(e) {
      const input = e && e.target ? e.target : null
      const resetInput = () => { if (input) input.value = '' }
      const file = input && input.files && input.files[0]
      if (!file || this.multiFiltersDisabled) { resetInput(); return }
      if (!/\.xlsx$/i.test(String(file.name || ''))) { this.$message.warning('仅支持导入 .xlsx 文件'); resetInput(); return }
      const actor = authState.user
      try {
        const wb = new ExcelJS.Workbook()
        await wb.xlsx.load(await file.arrayBuffer())
        if (this.selectionDestroyed || actor !== authState.user) return
        const ws = wb.worksheets && wb.worksheets[0]
        if (!ws) { this.$message.warning('未读取到工作表'); return }
        const toAdd = new Map()
        let invalid = 0
        ws.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return
          const raw = String(row.getCell(1).text || '').trim().toUpperCase()
          if (!raw) return
          const split = raw.lastIndexOf('_')
          const plate = split > 0 ? raw.slice(0, split) : raw
          const colorCell = String(row.getCell(2).text || '').trim()
          const color = split > 0 ? raw.slice(split + 1) : colorCell || (plate.length === 8 ? '3' : '2')
          if (!isLicensePlateFormatValid(plate) || !['1', '2', '3'].includes(color)) { invalid++; return }
          const key = this.multiSelectedVehicleKey(plate, color)
          toAdd.set(key, { vclN: plate, vco: color })
        })
        if (!toAdd.size) { this.$message.warning(invalid ? `未导入有效车牌（跳过${invalid}条）` : '未导入到车牌号'); return }
        const previous = new Set(this.multiSelectedVehicles.map(row => row._key))
        const added = Array.from(toAdd.keys()).filter(key => !previous.has(key)).length
        if (await this.addPlatesToServerSelectedList(Array.from(toAdd.values()))) {
          this.$message.success(`已导入 ${added} 条${invalid ? `（跳过${invalid}条无效记录）` : ''}`)
        }
      } catch (error) {
        if (!this.selectionDestroyed && actor === authState.user) this.$message.error(error.msg || error.message || '导入失败，请确认文件格式正确（.xlsx）')
      } finally { resetInput() }
    },
    async onMultiExport() {
      if (this.multiFiltersDisabled) return
      const sourceList = (this.multiSelectedVehicles && this.multiSelectedVehicles.length)
        ? this.multiSelectedVehicles
        : this.multiVehicleResultList
      if (!sourceList || !sourceList.length) {
        this.$message.warning('暂无车辆可导出')
        return
      }
      try {
        const wb = new ExcelJS.Workbook()
        wb.creator = '铁路管理系统'
        const ws = wb.addWorksheet('多车车牌')
        ws.columns = [{ header: '车牌号', key: 'plate', width: 18 }, { header: '车牌颜色', key: 'color', width: 12 }]
        const h = ws.getRow(1)
        h.font = { bold: true }
        h.alignment = { horizontal: 'center', vertical: 'middle' }
        const seen = new Set()
        for (const item of sourceList) {
          const raw = item && item.vclN != null ? String(item.vclN).trim() : ''
          if (!raw || raw === '—') continue
          const color = String(item.vco || '')
          const key = this.multiSelectedVehicleKey(raw, color)
          if (!['1', '2', '3'].includes(color) || seen.has(key)) continue
          seen.add(key)
          ws.addRow({ plate: raw, color })
        }
        if (seen.size === 0) {
          this.$message.warning('没有可导出的有效车牌')
          return
        }
        const buf = await wb.xlsx.writeBuffer()
        const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')
        saveAs(
          new Blob([buf], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }),
          `多车车牌导出_${stamp}.xlsx`
        )
        this.$message.success('导出成功')
      } catch (e) {
        console.error(e)
        this.$message.error('导出失败，请重试')
      }
      this.$emit('export-multi-vehicles', sourceList)
    },
    formatMultiLastRefresh() {
      if (this.lastMultiRefreshAt == null) return '—'
      const d = new Date(this.lastMultiRefreshAt)
      if (Number.isNaN(d.getTime())) return '—'
      return `${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}:${this.pad2(d.getSeconds())}`
    },
    /**
     * 接收父组件数据。插件页 getTruckLastLocation：单车「结果」仅使用接口里的 firstVcl（兼容误写 firstVol）；
     * 若传入的已是首车扁平对象（无 firstVcl 键），则原样作为 routeData。
     */
    updateRouteData(data) {
      if (data == null) {
        this.routeData = null
        return
      }
      if (typeof data !== 'object') {
        this.routeData = data
        if (this.showGaragePanel && data) {
          this.activeLowerTab = 'result'
        }
        return
      }
      if (data.firstVcl != null && typeof data.firstVcl === 'object') {
        this.routeData = data.firstVcl
        if (this.showGaragePanel) {
          this.activeLowerTab = 'result'
        }
        return
      }
      if (data.firstVol != null && typeof data.firstVol === 'object') {
        this.routeData = data.firstVol
        if (this.showGaragePanel) {
          this.activeLowerTab = 'result'
        }
        return
      }
      this.routeData = data
      if (this.showGaragePanel) {
        this.activeLowerTab = 'result'
      }
    },
    // 接收外部传入的搜索参数并更新筛选条件
    updateSearchForm(params) {
      if (!params) return
      if (params.vehicleMode === 'single' || params.vehicleMode === 'multi') {
        this.vehicleMode = params.vehicleMode
      }
      const vnosRaw = params.vnos != null && String(params.vnos).trim() !== '' ? String(params.vnos).trim() : ''
      const vnosSegCount = vnosRaw ? vnosRaw.split(',').map((s) => s.trim()).filter(Boolean).length : 0
      const echoSingleFromVnos = params.pluginEchoSingleFromVnos === true && vnosRaw && vnosSegCount === 1

      if (echoSingleFromVnos) {
        this.vehicleMode = 'single'
        const parsed = this.parseVnosString(vnosRaw)
        const one = parsed[0]
        if (one) {
          this.searchForm.licensePlate = one.vclN
          this.searchForm.licensePlateColor = String(one.vco != null ? one.vco : '2')
        }
        this.multiSelectedVehicles = []
        // 不 return：继续应用始发地/目的地等字段
      } else if (vnosRaw) {
        this.vehicleMode = 'multi'
        const parsed = this.parseVnosString(vnosRaw)
        this.multiSelectedVehicles = parsed.map((p) => ({
          vclN: p.vclN,
          vco: p.vco,
          _key: this.multiSelectedVehicleKey(p.vclN, p.vco)
        }))
        return
      }
      if (params.vclN) this.searchForm.licensePlate = params.vclN
      if (params.vco) this.searchForm.licensePlateColor = String(params.vco)
      if (params.startLonlat) this.searchForm.originCoord = params.startLonlat
      if (params.endLonlat) this.searchForm.destCoord = params.endLonlat
      if (params.startAreaCode != null && String(params.startAreaCode).trim() !== '') {
        const c = String(params.startAreaCode).trim()
        this.searchForm.startAreaCode = c
        const p = this.findRegionPathByCode(c)
        this.selectedAreaOrigin = p.length ? p : []
      }
      if (params.endAreaCode != null && String(params.endAreaCode).trim() !== '') {
        const c = String(params.endAreaCode).trim()
        this.searchForm.endAreaCode = c
        const p = this.findRegionPathByCode(c)
        this.selectedAreaDest = p.length ? p : []
      }
    },
  }
}
</script>
<style scoped>
.leftjoin-root ::v-deep .el-form-item {
  margin-bottom: 0.3rem;
}
.leftjoin-root ::v-deep .el-form--label-top .el-form-item__label {
  padding: 0 !important;
  font-size: 0.875rem !important;
}
.leftjoin-root ::v-deep .el-range-editor.el-input__inner {
  height: 2.1rem !important;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 0 0.5rem !important;
}

/* 调整输入框样式（限定在侧栏内，避免污染其他页面） */
.leftjoin-root ::v-deep .el-input__inner,
.leftjoin-root ::v-deep .el-select__inner,
.leftjoin-root ::v-deep .el-checkbox__label,
.leftjoin-root ::v-deep .el-form-item__error {
  font-size: 0.875rem !important;
  height: 2rem !important;
}

.leftjoin-root ::v-deep .el-checkbox__inner {
  width: 1rem !important;
  height: 1rem !important;
}

.leftjoin-root ::v-deep .el-dialog__body,
.monitor-add-vehicle-dialog ::v-deep .el-dialog__body,
.add-vehicle-dialog ::v-deep .el-dialog__body {
  padding: 0 1.25rem 0.625rem !important;
}

.multi-add-vehicle-dialog ::v-deep .el-dialog__header {
  padding: 0.875rem 1.25rem 0.75rem;
  border-bottom: 1px solid #e4e7ed;
}

.multi-add-vehicle-dialog ::v-deep .el-dialog__title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
  color: #303133;
}

.multi-add-vehicle-dialog ::v-deep .el-dialog__body {
  padding: 0.75rem 1.25rem 0.625rem !important;
  overflow: visible;
}

.vehicle-add-vco-popper::v-deep .el-select-dropdown {
  z-index: 4000 !important;
}

.vehicle-add-vco-popper ::v-deep .el-scrollbar__bar {
  display: none;
}
</style>

<style scoped>
.leftjoin-root {
  position: relative;
  height: 100%;
  /* z-index: 10; */
}

.main-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 23rem;
    min-width: 23.5rem;
  max-width: 31.5rem;
  height: 100%;
  overflow-y: hidden;
  transition: width 0.3s ease;
}

.main-content.collapsed {
  width: 0;
  min-width: 0;
  overflow: hidden;
}

/* 侧栏边缘梯形标签：左侧竖直，上下边向右倾斜，右侧竖边较短（clip-path） */
.toggle-btn {
position: absolute;
    top: 44%;
    left: 23.5rem;
    transform: translateY(-44%);
    width: 1.2rem;
    height: 5rem;
    padding: 0;
    background-color: #668bfa;
    border: none;
    border-radius: 0 1rem 1rem 0;
    clip-path: polygon(0% 0%, 100% 8%, 100% 92%, 0% 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 11;
    transition: left 0.3s ease, filter 0.2s ease;
    outline: none;
    text-align: center;
}



.toggle-btn i {
  font-size: 0.875rem;
  color: #fff;
}

/* 收起时箭头朝右：梯形水平镜像，贴边一侧仍为竖直长边 */
.toggle-btn.collapsed {
  left: 0;
  clip-path: polygon(0% 0%, 100% 8%, 100% 92%, 0% 100%);
}

.left-panel {
  width: 100%;
  height: 100%;
  padding: 0.9375rem;
  box-sizing: border-box;
  background-color: #fffc;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.mode-toggle {
  flex-shrink: 0;
  margin-bottom: 0.2rem;
}

.mode-toggle__inner {
  width: 100%;
  display: flex;
}

.mode-toggle__inner ::v-deep .el-radio-button {
  flex: 1;
}

.mode-toggle__inner ::v-deep .el-radio-button__inner {
  width: 100%;
}

.multi-selected-slot {
  flex-shrink: 0;
  margin-top: 0.5rem;
}

.multi-garage-slot {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.multi-garage-slot >>> .lj-garage-panel {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.multi-garage-slot >>> .vehicle-tree-wrap {
  flex: 1;
  min-height: 0;
  max-height: none;
}

/* 多车筛选：已选列表 + 工具条（与单车表单区分） */
.multi-filter-panel {
  flex-shrink: 0;
  padding: 0.75rem;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.08);
}

.multi-filter-panel--above-garage {
  margin-top: 0;
  margin-bottom: 0.25rem;
  padding: 0.625rem 0.75rem;
}

.multi-filter-panel--in-tab {
  margin-top: 0;
  margin-bottom: 0;
}

.multi-filter-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0;
}

.multi-filter-toolbar__left {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  flex: 1;
}

.multi-filter-toolbar__toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--layout-primary, #087dff);
  font-size: 0.8125rem;
  cursor: pointer;
  flex-shrink: 0;
}

.multi-filter-toolbar__toggle:hover:not(:disabled) {
  color: var(--layout-primary-hover, #0670e6);
}

.multi-filter-toolbar__toggle:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.multi-filter-toolbar__toggle i {
  font-size: 0.75rem;
}

.multi-filter-toolbar__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #303133;
}

.multi-selected-dialog__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.multi-selected-dialog__search {
  margin-bottom: 0.75rem;
}

.multi-selected-dialog__table {
  width: 100%;
}

.multi-selected-dialog__query {
  font-weight: 600;
}

.multi-selected-dialog__query.is-pending {
  color: #409eff;
}

.multi-selected-dialog__query.is-done {
  color: #303133;
}

.multi-selected-dialog__query.is-empty {
  color: #909399;
}

.multi-selected-dialog__status {
  font-weight: 600;
}

.multi-selected-dialog__status.is-online {
  color: #67c23a;
}

.multi-selected-dialog__status.is-stop {
  color: #f56c6c;
}

.multi-selected-dialog__status.is-offline {
  color: #909399;
}

.multi-filter-toolbar__right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.multi-filter-toolbar__add {
  padding: 0.5rem !important;
  border: none;
  box-shadow: 0 0.0625rem 0.25rem var(--layout-primary-focus-shadow, rgba(8, 125, 255, 0.2));
}

.multi-filter-toolbar__query {
  padding: 0.5rem 1rem !important;
  border-radius: 0.375rem;
  font-weight: 500;
}

.multi-filter-list-wrap {
  min-height: 3rem;
  max-height: 8rem;
  overflow-y: auto;
  padding: 0.5rem 0.625rem;
  border: 0.0625rem solid #dcdfe6;
  border-radius: 0.5rem;
  box-sizing: border-box;
}

.multi-filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.375rem 0;
}

.multi-filter-row:last-of-type {
  border-bottom: none;
}

.multi-filter-tag {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #333;
  border-radius: 0.25rem;
  border: none;
  line-height: 1.2;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multi-filter-tag--yellow {
  background: #efd244;
}

.multi-filter-tag--blue {
  background: var(--layout-primary, #087dff);
}

.multi-filter-tag--green {
  background: linear-gradient(90deg, #67c23a, #a6e22e);
}

.multi-filter-remove {
  flex-shrink: 0;
  padding: 0 !important;
  font-size: 0.8125rem;
}

.multi-filter-empty {
  padding: 1.25rem 0.5rem;
  text-align: center;
  font-size: 0.8125rem;
  color: #909399;
}

.multi-add-dialog-body {
  padding: 0 0.125rem;
}

.monitor-add-dialog__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 2.5rem;
  gap: 0.75rem;
}
.monitor-add-dialog__title-text {
  font-size: 1rem;
  font-weight: 600;
  color: #303133;
}
.monitor-add-dialog__body {
  padding: 0 0.125rem;
}
.monitor-add-dialog__search-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.monitor-add-dialog__search-row >>> .el-input__prefix,
.monitor-add-dialog__search-row >>> .el-input__suffix {
  margin-top: -0.1875rem !important;
}
.monitor-add-dialog__search {
  flex: 1;
  min-width: 0;
}
.monitor-add-dialog__table {
  width: 100%;
}
.monitor-add-dialog__footer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  font-size: 0.8125rem;
  color: #606266;
}
.monitor-add-dialog__pagination {
  width: 100%;
}

.multi-add-line-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.multi-add-line-add {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.25rem;
  cursor: pointer;
  color: var(--layout-primary, #087dff);
  font-size: 0.875rem;
  font-weight: 500;
  user-select: none;
}

.multi-add-batch-btn {
  margin-left: auto;
  padding: 0 !important;
  font-size: 0.8125rem;
}

.multi-add-batch-wrap {
  margin-bottom: 0.5rem;
}

.multi-add-batch-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.multi-add-batch-textarea {
  flex: 1;
  min-width: 0;
}

.multi-add-batch-row > ::v-deep .el-button {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.multi-add-batch-textarea >>> textarea {
  line-height: 1.4;
  font-size: 0.8125rem;
}

.multi-add-line-add:hover {
  opacity: 0.88;
}

.multi-add-rows {
  overflow-x: hidden;
  overflow-y: visible;
}

.multi-add-rows--scroll {
  max-height: 16rem;
  overflow-y: auto;
}

.multi-add-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.625rem;
  overflow: hidden;
  min-width: 0;
}

.multi-add-row:last-child {
  margin-bottom: 0;
}

.multi-add-row__del {
  flex-shrink: 0;
  padding: 0.25rem !important;
  min-width: 2rem;
  color: #909399;
}

.multi-add-row__del:hover {
  color: #f56c6c;
}

.multi-add-row__plate {
  flex: 1;
  min-width: 0;
}

.multi-add-row__vco {
  width: 5.75rem;
  flex-shrink: 0;
}

.bicycle-form {
  flex-shrink: 0;
}

.single-filter-section {
  flex-shrink: 0;
}

.single-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height:1.4rem;
  margin: 0.375rem 0 0;
  padding: 0;
  border: 1px solid var(--layout-primary, #087dff);
  border-radius: 0.375rem;
  background: #fff;
  color: var(--layout-primary, #087dff);
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.single-filter-toggle:hover {
  background: var(--layout-primary-soft, rgba(8, 125, 255, 0.08));
  border-color: var(--layout-primary-light, #4da3ff);
  color: var(--layout-primary-hover, #0670e6);
}

.single-filter-toggle i {
  font-size: 1rem;
  line-height: 1;
}

.single-filter-search-item {
  margin-bottom: 0.8rem;
}

.single-filter-search-item >>> .el-form-item__content {
  line-height: normal;
}

.lower-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.lower-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.lower-tabs ::v-deep .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.lower-tabs ::v-deep .el-tab-pane {
 height: 20rem;
}

.garage-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.vehicle-tree {
  max-height: 16rem;
  overflow-y: auto;
  font-size: 0.875rem;
}

.tab-placeholder {
  padding: 1rem;
  color: #909399;
  font-size: 0.875rem;
}

.history-vehicle-panel {
  /* height: 100%; */
  min-height: 14rem;
  display: flex;
  flex-direction: column;
}

.history-vehicle-toolbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.history-vehicle-toolbar__search {
  flex: 1;
  min-width: 0;
}

.history-vehicle-panel__layout {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  flex: 1;
  min-height: 0;
}



.history-vehicle-panel__main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}


.history-vehicle-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: 0.3125rem 0 0.625rem rgba(0, 0, 0, 0.3);
  border-radius: 0.1875rem;
}

.history-vehicle-scroll--list {
  padding: 0.375rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.25rem;
}

.history-vehicle-card {
     background: #fffc;
    border-radius: 0.25rem;
    padding: 0.625rem 0.75rem;
    margin-bottom: 0.5rem;
    box-shadow: none;
    box-shadow: 0 0 0.3125rem 0 rgba(0, 0, 0, 0.3);
}

.history-vehicle-card__delete {
  float: right;
  border: none;
  background: transparent;
  color: #909399;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.history-vehicle-card__delete:hover {
  color: #f56c6c;
}

.history-vehicle-card:last-child {
  margin-bottom: 0;
}

.history-vehicle-card--clickable {
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.history-vehicle-card--clickable:hover {
  background: #f5f7fa;
  box-shadow: 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.08);
}

.history-vehicle-card--clickable:focus {
  outline: none;
  box-shadow: 0 0 0 0.125rem var(--layout-primary-focus-shadow, rgba(8, 125, 255, 0.2));
}

.history-vehicle-card__plate {
    font-size: 1rem;
    font-weight: bold;
    color: #303133;
    margin-bottom: 0.3rem;
    line-height: 1;
}

.history-vehicle-card__row {
  font-size: 0.8125rem;
  line-height: 1.55;
  color: #606266;
  margin-bottom: 0.2rem;
}

.history-vehicle-card__detail {
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #606266;
  margin-top: 0.25rem;
}

.result-panel--in-tab {
  box-shadow: none;
  padding: 0.25rem 0;
  margin: 0;
}

/* 多车：已选车辆（结果 Tab） */
.multi-result-wrap {
  padding: 0;
  margin: 0;
  min-height: 14rem;
  height: 100%;
  box-sizing: border-box;
}

.multi-result-shell {
  background: #e8eaed;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 17rem;
  max-height: 22rem;
  box-shadow: 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.08);
}

.multi-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.625rem;
  background: #fff;
  border-bottom: 0.0625rem solid #e4e7ed;
  flex-shrink: 0;
}

.multi-result-header__left {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.multi-result-header__lead-iconall {
  color: var(--layout-primary, #087dff);
  font-size: 1.125rem;
  width: 1.25rem;
}

.multi-result-header__lead-icon {
  color: var(--layout-primary, #087dff);
  font-size: 1.125rem;
  width: 2rem;
  position: absolute;
  top: 0.75rem;
}

.multi-result-header__title {
  font-weight: 700;
  font-size: 0.875rem;
  color: #303133;
}

.multi-result-header__count {
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.3rem;
  border-radius: 62.5rem;
  background: var(--layout-primary, #087dff);
  color: #fff;
  font-size: 0.625rem;
  line-height: 1.125rem;
  text-align: center;
  font-weight: 600;
}

.multi-result-header__actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.multi-result-header__search {
  width: 9.5rem;
}

.multi-result-header__action {
  font-size: 1rem;
  color: #606266;
  cursor: pointer;
  transition: color 0.2s;
}

.multi-result-header__action:hover {
  color: var(--layout-primary, #087dff);
}

/* .multi-result-header__chevron {
  font-size: 0.8125rem;
  color: #909399;
  cursor: pointer;
  margin-left: 0.125rem;
}

.multi-result-header__chevron:hover {
  color: var(--layout-primary, #087dff);
} */

.multi-result-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem;
  scrollbar-width: thin;
}

.multi-result-empty {
  padding: 2rem 0.75rem;
  text-align: center;
  color: #909399;
  font-size: 0.8125rem;
}

.multi-vehicle-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  background: #fff;
  border-radius: 0.5rem;
  padding: 0.625rem 1.75rem 0.625rem 0.625rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.06);
  border: 0.0625rem solid #ebeef5;
  transition: box-shadow 0.2s;
}

.multi-vehicle-card:last-child {
  margin-bottom: 0;
}

.multi-vehicle-card:hover {
  box-shadow: 0 0.25rem 0.75rem var(--layout-primary-soft, rgba(8, 125, 255, 0.08));
}

.multi-vehicle-card__icon-wrap {
  position: relative;
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.multi-vehicle-card__truck {
  font-size: 1.5rem;
  color: var(--layout-primary, #087dff);
}

.multi-vehicle-card__dot {
  position: absolute;
  right: 1.25rem;
  bottom: 0.625rem;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  border: 0.125rem solid #fff;
  box-sizing: content-box;
}

.multi-vehicle-card__dot.is-online {
  background: #52c41a;
}

.multi-vehicle-card__dot.is-stop {
  background: #f56c6c;
}

.multi-vehicle-card__dot.is-offline {
  background: #909399;
}

.multi-vehicle-card__main {
  flex: 1;
  min-width: 0;
}

.multi-vehicle-card__plate {
  font-size: 1rem;
  font-weight: 700;
  color: #303133;
  line-height: 1.3;
  margin-bottom: 0.15rem;
}

.multi-vehicle-card__alias {
  font-size: 0.75rem;
  color: #909399;
  margin-bottom: 0.3rem;
}

.multi-vehicle-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  font-size: 0.75rem;
  color: #606266;
}

.multi-vehicle-card__meta-item {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.multi-vehicle-card__meta-item i {
  color: #909399;
  font-size: 0.8125rem;
}

.multi-vehicle-card__remove {
  position: absolute;
  top: 0.45rem;
  right: 0.45rem;
  font-size: 0.875rem;
  color: #c0c4cc;
  cursor: pointer;
  transition: color 0.2s;
}

.multi-vehicle-card__remove:hover {
  color: #f56c6c;
}

.multi-result-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.45rem 0.625rem;
  background: #f0f2f5;
  border-top: 0.0625rem solid #ebeef5;
  font-size: 0.75rem;
  color: #606266;
  flex-shrink: 0;
}

.multi-result-footer__refresh {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.multi-result-footer__export {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--layout-primary, #087dff);
  cursor: pointer;
  font-weight: 500;
}

.multi-result-footer__export:hover {
  text-decoration: underline;
}

/* 表单布局 */
.form-row {
  display: flex;
  gap: 0.9375rem;
  align-items: flex-end;
  margin-bottom: 0.3125rem;
  flex-wrap: wrap;
}

.form-item {
  flex: 1;
  margin-bottom: 0 !important;
  min-width: 10rem;
}

/* 时间输入框布局 */
.time-row {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex-wrap: wrap;
}

.time-input {
  flex: 1;
}

.time-separator {
  margin: 0 0.3125rem;
  color: #606266;
}

/* 复选框布局 */
.checkbox-item {
  display: flex;
  align-items: flex-end;
  gap: 0.9375rem;
  padding-bottom: 0.125rem;
  flex-wrap: wrap;
}




/* 调整按钮样式 */
.search-btn {
  width: 100%;
  margin-top: 0.625rem;
  height: 2.25rem;
  font-size: 0.875rem;
  background-color: var(--layout-primary, #087dff);
}

.result-panel {
  padding: 0.9375rem;
  border-radius: 0.5rem;
  box-shadow: 0.3125rem 0 0.625rem rgba(0, 0, 0, 0.08);
  flex: 1;
  overflow-y: auto;
  margin-bottom: 0;
}

.result-title {
  font-size: 1rem;
  line-height:2.25rem;
  color: #333;
  /* 核心属性：添加下划线 */
  text-decoration: underline;
  /* 可选：自定义下划线样式 */
  text-decoration-color: var(--layout-primary, #087dff); /* 下划线颜色（比如你项目的主题蓝） */
  text-decoration-thickness: 0.125rem; /* 下划线粗细 */
  text-underline-offset: 0.25rem; /* 下划线与文字的距离（避免贴太紧） */
}


.result-panel h3 {
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  color: #303133;
}

.result-panel .result-item {
  margin-bottom: 0.625rem;
  font-size: 0.875rem !important;
}

.result-status {
  font-weight: 600;
}

.result-status.is-online {
  color: #52c41a;
}

.result-status.is-stop {
  color: #f56c6c;
}

.result-status.is-offline {
  color: #909399;
}

/* 地图弹窗样式 */
.map-dialog-content {
  height: 50vh;
  position: relative;
}

.map-search {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  background-color: white;
  padding: 0.5rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
}

/* 确保下拉框显示在最上层 */
::v-deep .el-autocomplete__suggestions {
  z-index: 10000 !important;
}

.map-container {
  width: 100%;
  height: 100%;
}

.leftjoin-map-prewarm {
  position: fixed;
  left: -625rem;
  top: 0;
  width: 64rem;
  height: 40rem;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}

.leftjoin-map-singleton-el {
  width: 100%;
  height: 100%;
}

.add-group-form >>> .el-form-item__label {
  text-align: right;
}

.add-group-form >>> .el-form-item {
  margin-bottom: 1.25rem !important;
}

.add-group-form >>> .el-form-item.is-error {
  margin-bottom: 2rem !important;
}

.add-group-form >>> .el-form-item__content {
  line-height: 2rem;
}

.add-group-form >>> .el-form-item__error {
  padding-top: 0.125rem;
  line-height: 1.25;
  white-space: normal;
}

@media (max-width: 768px) {
  .main-content {
    width: min(23rem, calc(100vw - 1.5rem));
    min-width: 0;
    max-width: calc(100vw - 1.5rem);
  }

  .toggle-btn {
    left: min(23.5rem, calc(100vw - 1.5rem));
  }

  .left-panel {
    padding: 0.625rem;
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .form-item {
    min-width: 0;
    width: 100%;
  }
}

</style>

<style>
.multi-selected-dropdown-popper {
  padding: 0.375rem 0 !important;
  max-height: 14rem;
  overflow-y: auto;
}

.add-vehicle-dialog .el-dialog__body {
  overflow: visible;
  padding-bottom: 1.25rem;
}
</style>
